import React, { useEffect, useState, useCallback } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useBottomScrollListener } from "react-bottom-scroll-listener";
import { useNavigate  } from "react-router-dom";
import Home from "../Home";
import Breadcrumb from "../../components/Breadcrumb";
import SalesMaintenance from "../SalesMaintenance";
import errorMessages from "../../common/errorMessages";
import { Accordion, Spinner, Modal } from "react-bootstrap";
import { Select } from "antd";
import DatePicker from "react-datepicker";
import {
  fetchMarketAuthorizationList,
  fetchFormList,
  fetchFormulationList,
  fetchPackagingList,
  fetchCountyList,
  fetchTargetPeriod,
  fetchWholesalerLevelList,
  getSelloutRotationCAReportList,
  fetchProductTypeList,
  fetchHempLawList,
  fetchFixedMonth,
  fetchMaintenanceList,
  fetchProductsList,
  fetchEvaluationTargetClassificationList,
  fetchTwoHundredBedsList,
  fetchHundredBedsList,
} from "./actions";
import { LOAD_MORE_PAGE_SIZE } from "../../constants/pagination";

function SelloutRotationWholesaler() {
  const navigate = useNavigate();
  const [lang] = useTranslation("language");
  const [allSelected, setAllSelected] = useState(0);
  const [showUserMessage, setShowUserMessage] = useState(false);
  const [showDownloadMessage, setShowDownloadMessage] = useState(false);
  const [noData, setNoData] = useState(false);
  const [loading, setLoading] = useState(false);
  const [excelLoading, setExcelLoading] = useState(false);
  const [downloadMessage, setDownloadMessage] = useState("");
  const [duration, setDuration] = useState("fixedMonthJP");
  const [jpFromDateDisplay, setJPFromDateDisplay] = useState("");
  const [jpToDateDisplay, setJPToDateDisplay] = useState("");
  const [wholesaleFromDateDisplay, setWholesaleFromDateDisplay] = useState("");
  const [wholesaleToDateDisplay, setWholesaleToDateDisplay] = useState("");
  const [jpFromDate, setJPFromDate] = useState("");
  const [jpToDate, setJPToDate] = useState("");
  const [wholesaleFromDate, setWholesaleFromDate] = useState("");
  const [wholesaleToDate, setWholesaleToDate] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [fromDateDisplay, setFromDateDisplay] = useState("");
  const [toDateDisplay, setToDateDisplay] = useState("");
  const [processingDate, setProcessingDate] = useState("");
  const [personInCharge, setPersonInCharge] = useState("");
  const [organizationName, setOrganizationName] = useState("");
  const [hundredFloorId, setHundredFloorId] = useState("");
  const [twoHundredFloorId, setTwoHundredFloorId] = useState("");
  const [productType, setProductType] = useState([]);
  const [selectedHempLaw, setSelectedHempLaw] = useState([]);
  const [salesCompany, setSalesCompany] = useState("ALL");
  const [sortItem, setSortItem] = useState("currentYear");
  const [numericalItem, setNumericalItem] = useState("salesAmount");
  const [lazyLoading, setLazyLoading] = useState(false);
  const [marketLoading, setMarketLoading] = useState(false);
  const [formLoading, setFormLoading] = useState(false);
  const [formulationLoading, setFormulationLoading] = useState(false);
  const [packLoading, setPackLoading] = useState(false);
  const [cityLoading, setCityLoading] = useState(false);
  const [isScreenLoading, setIsScreenLoading] = useState(true);
  const [limit, setLimit] = useState(LOAD_MORE_PAGE_SIZE);
  const [total, setTotal] = useState(0);
  const [maintenance, setMaintenance] = useState("");
  const [sortField, setSortField] = useState("");
  const [sortOrder, setSortOrder] = useState("");

  const [sortCorporationName, setSortCorporationName] = useState("asc");
  const [sortParentFacility, setSortParentFacility] = useState("asc");
  const [sortDeliveryFacility, setSortDeliveryFacility] = useState("asc");
  const [sortProduct, setSortProduct] = useState("asc");
  const [sortMarket, setSortMarket] = useState("asc");
  const [sortForm, setSortForm] = useState("asc");
  const [role, setRole] = useState(false);
  const [sortFormulation, setSortFormulation] = useState("asc");
  const [sortPack, setSortPack] = useState("asc");
  const [sortNonDeliveryPeriod, setSortNonDeliveryPeriod] = useState("asc");
  const [loginName, setLoginName] = useState("");

  const [wholesaleLoading, setWholesaleLoading] = useState(false);
  const [wholesaleCorporationLoading, setWholesaleCorporationLoading] =
    useState(false);
  const [wholesaleManagementSalesLoading, setWholesaleManagementSalesLoading] =
    useState(false);
  const [wholesaleSalesLoading, setWholesaleSalesLoading] = useState(false);
  const [wholesaleBranchLoading, setWholesaleBranchLoading] = useState(false);
  const [wholesaleBranchSectionLoading, setWholesaleBranchSectionLoading] =
    useState(false);

  const [hempLawList, setHempLawList] = useState([]);
  const [productsList, setProductsList] = useState([]);
  const [marketAuthList, setMarketAuthList] = useState([]);
  const [formList, setFormList] = useState([]);
  const [formulationList, setFormulationList] = useState([]);
  const [packagingList, setPackagingList] = useState([]);
  const [hundredBedsList, setHundredBedsList] = useState([]);
  const [twoHundredBedsList, setTwoHundredBedsList] = useState([]);
  const [prefectureList, setPrefectureList] = useState([]);
  const [countyList, setCountyList] = useState([]);
  const [productTypeList, setProductTypeList] = useState([]);
  const [wholesalerGroupList, setWholesalerGroupList] = useState([]);
  const [wholesalerCorporationList, setWholesalerCorporationList] = useState(
    []
  );
  const [wholesalerManagementList, setWholesalerManagementList] = useState([]);
  const [wholesalerSalesList, setWholesalerSalesList] = useState([]);
  const [wholesalerBranchList, setWholesalerBranchList] = useState([]);
  const [wholesalerBranchSectionList, setWholesalerBranchSectionList] =
    useState([]);
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [selectedMarketAuth, setSelectedMarketAuth] = useState([]);
  const [selectedForm, setSelectedForm] = useState([]);
  const [selectedFormulation, setSelectedFormulation] = useState([]);
  const [selectedPackaging, setSelectedPackaging] = useState([]);
  const [selectedWholesalerGroupList, setSelectedWholesalerGroupList] =
    useState([]);
  const [
    selectedWholesalerCorporationList,
    setSelectedWholesalerCorporationList,
  ] = useState([]);
  const [
    selectedWholesalerManagementList,
    setSelectedWholesalerManagementList,
  ] = useState([]);
  const [selectedWholesalerSalesList, setSelectedWholesalerSalesList] =
    useState([]);
  const [selectedWholesalerBranchList, setSelectedWholesalerBranchList] =
    useState([]);
  const [
    selectedWholesalerBranchSectionList,
    setSelectedWholesalerBranchSectionList,
  ] = useState([]);
  const [selectedPrefecture, setSelectedPrefecture] = useState([]);
  const [selectedCounty, setSelectedCounty] = useState([]);
  const [targetPeriodYearList, setTargetPeriodYearList] = useState([]);
  const [reportListing, setReportListing] = useState([]);
  const [headers, setHeaders] = useState([]);
  const routes = [
    {
      name: `${lang("Menu.home")}`,
      path: "/",
    },
    {
      name: `${lang("SalesMenu.selloutRotationByWholesaler")}`,
      path: "/selloutRotationReportWholeSaler",
    },
  ];

  const options = [
    { value: "option1", label: "Option 1" },
    { value: "option2", label: "Option 2" },
    { value: "option3", label: "Option 3" },
  ];

  const details = useSelector((state) => state.salesReport.selloutWholesaler);
  var personName;
  if (sessionStorage.getItem("User role") === "MR") {
    personName = sessionStorage.getItem("Kanji name");
  } else {
    personName = "";
  }
  if (details.length > 1) {
    personName = "複数選択";
  } else if (details.length === 0) {
    if (sessionStorage.getItem("User role") === "MR") {
      personName = sessionStorage.getItem("Kanji name");
    } else {
      personName = "";
    }
  } else if (details.length === 1) {
    if (details[0].role_code === "5003") {
      personName = details[0].name_kanji;
    } else personName = "";
  }

  const current = new Date();
  const startDate = new Date(current.getFullYear() - 3, current.getMonth() - 4, 1);
  const endDate = new Date(current.getFullYear(), current.getMonth() + 1, 0);

  useEffect(() => {
    const token = sessionStorage.getItem("token");
    sessionStorage.setItem("return_url", "/selloutRotationReportWholeSaler");
    const productList = sessionStorage.getItem("Product");
    const marketAuthList = sessionStorage.getItem("Market Auth List");
    const formList = sessionStorage.getItem("Form");
    const formulationList = sessionStorage.getItem("Formulation");
    const packList = sessionStorage.getItem("Pack");
    const hundredBedsList = sessionStorage.getItem("Hundred beds sales");
    const twoHundredBedsList = sessionStorage.getItem("Two hundred beds sales");
    const role = sessionStorage.getItem("User role");
    if(role === "CA" || role === "Admin" || role === "SalesManager" || role === "BusinessOperation" || role === "Wholesaler"){
      setRole(true);
    }else{
      setRole(false);
    }
    const salesPrefectureList = sessionStorage.getItem("Sales prefecture");
    const wholesaleLevelOneList = sessionStorage.getItem(
      "Wholesaler Level One"
    );
    const wholesaleLevelTwoList = sessionStorage.getItem(
      "Wholesaler Level Two"
    );
    const wholesaleLevelThreeList = sessionStorage.getItem(
      "Wholesaler Level Three"
    );
    const wholesaleLevelFourList = sessionStorage.getItem(
      "Wholesaler Level Four"
    );
    const wholesaleLevelFiveList = sessionStorage.getItem(
      "Wholesaler Level Five"
    );
    const wholesaleLevelSixList = sessionStorage.getItem(
      "Wholesaler Level Six"
    );
    let name = sessionStorage.getItem("Kanji name");
    setLoginName(name);
    let products = JSON.parse(productList);
    let newList = [];
    for (let i = 0; i < products?.length; i++) {
      newList.push(products[i]);
    }
    setProductsList(newList);
    // newList && newList[0] && setSelectedProducts([newList[0].value]);
    setMarketAuthList(JSON.parse(marketAuthList));
    setFormList(JSON.parse(formList));
    setFormulationList(JSON.parse(formulationList));
    setPackagingList(JSON.parse(packList));
    hundredBedsList && setHundredBedsList(JSON.parse(hundredBedsList));
    twoHundredBedsList && setTwoHundredBedsList(JSON.parse(twoHundredBedsList));
    hundredBedsList &&
      JSON.parse(hundredBedsList)[0] &&
      setHundredFloorId(JSON.parse(hundredBedsList)[0].value);
    twoHundredBedsList &&
      JSON.parse(twoHundredBedsList)[0] &&
      setTwoHundredFloorId(JSON.parse(twoHundredBedsList)[0].value);
    setPrefectureList(JSON.parse(salesPrefectureList));
    setPersonInCharge(sessionStorage.getItem("WWID"));
    setOrganizationName(sessionStorage.getItem("Organization name"));
    !sessionStorage.getItem("Product") && getProductList();
    !sessionStorage.getItem("Market Auth List") && getMarketAuthorizationList();
    !sessionStorage.getItem("Form") && getFormList();
    !sessionStorage.getItem("Formulation") && getFormulationList();
    !sessionStorage.getItem("Pack") && getPackList();
    !sessionStorage.getItem("Hundred beds sales") && getHundredBedsList();
    !sessionStorage.getItem("Two hundred beds sales") &&
      getTwoHundredBedsList();
    !sessionStorage.getItem("Evaluation target classification") &&
      getEvaluationTargetClassificationList();
    setWholesalerGroupList(JSON.parse(wholesaleLevelOneList));
    setWholesalerCorporationList(JSON.parse(wholesaleLevelTwoList));
    setWholesalerManagementList(JSON.parse(wholesaleLevelThreeList));
    setWholesalerSalesList(JSON.parse(wholesaleLevelFourList));
    setWholesalerBranchList(JSON.parse(wholesaleLevelFiveList));
    setWholesalerBranchSectionList(JSON.parse(wholesaleLevelSixList));
    token && getTargetPeriod();
    getWholesalerGroupList();
    getProductTypeList();
    getFixedMonth();
    getHempLawList();
    getMaintenanceTime();
  }, []);

  /*** 
  @purpose : Get hundred beds sales list
  @Parameter : {}
  **/
  const getHundredBedsList = async () => {
    await fetchHundredBedsList().then((res) => {
      let newList = [];
      for (let index = 0; index < res.length; index++) {
        const item = res[index];
        newList.push({
          value: item.code,
          label: item.value,
        });
      }
      setHundredFloorId(newList[0].value);
      setHundredBedsList(newList);
      sessionStorage.setItem("Hundred beds sales", JSON.stringify(newList));
    });
  };

  /*** 
  @purpose : Get two hundred beds sales list
  @Parameter : {}
  **/
  const getTwoHundredBedsList = async () => {
    await fetchTwoHundredBedsList().then((res) => {
      let newList = [];
      for (let index = 0; index < res.length; index++) {
        const item = res[index];
        newList.push({
          value: item.code,
          label: item.value,
        });
      }
      setTwoHundredFloorId(newList[0].value);
      setTwoHundredBedsList(newList);
      sessionStorage.setItem("Two hundred beds sales", JSON.stringify(newList));
    });
  };

  /*** 
  @purpose : Get evaluation target classification
  @Parameter : {}
  **/
  const getEvaluationTargetClassificationList = async () => {
    await fetchEvaluationTargetClassificationList().then((res) => {
      let newList = [];
      for (let index = 0; index < res.length; index++) {
        const item = res[index];
        newList.push({
          value: item.code,
          label: item.value,
        });
      }
      sessionStorage.setItem(
        "Evaluation target classification",
        JSON.stringify(newList)
      );
    });
  };

  /*** 
  @purpose : Get product list
  @Parameter : {}
  **/
  const getProductList = async () => {
    await fetchProductsList().then((res) => {
      let newList = [];
      if (res && res.length > 0) {
        for (let index = 0; index < res.length; index++) {
          const item = res[index];
          newList.push({
            value: item.prdctlvl_cd,
            label: item.prdctlvl_sym,
          });
        }
        setProductsList(newList);
        sessionStorage.setItem("Product", JSON.stringify(newList));
      }
    });
  };

  /*** 
  @purpose : Get market auth list
  @Parameter : {}
  **/
  const getMarketAuthorizationList = async () => {
    let body = {
      prdctlvl_cd: "ALL",
    };
    await fetchMarketAuthorizationList(body).then((response) => {
      let newList = [];
      if (response && response.data && response.data.length > 0) {
        for (let index = 0; index < response.data.length; index++) {
          const item = response.data[index];
          newList.push({ value: item.aprlvl_cd, label: item.aprlvl_sym });
        }
        setMarketAuthList(newList);
        sessionStorage.setItem("Market Auth List", JSON.stringify(newList));
      }
    });
  };

  /*** 
  @purpose : Get form list
  @Parameter : {}
  **/
  const getFormList = async () => {
    let body = {
      aprlvl_cd: "ALL",
      // "market_authorization": "ALL"
    };
    await fetchFormList(body).then((response) => {
      let newList = [];
      if (response && response.data && response.data.length > 0) {
        for (let index = 0; index < response.data.length; index++) {
          const item = response.data[index];
          newList.push({ value: item.frmlvl_cd, label: item.frmlvl_sym });
        }
        setFormList(newList);
        sessionStorage.setItem("Form", JSON.stringify(newList));
      }
    });
  };

  /*** 
  @purpose : Get formulation list
  @Parameter : {}
  **/
  const getFormulationList = async () => {
    let body = {
      frmlvl_cd: "ALL",
      // "market_authorization": "ALL",
      // "form_codes": "ALL"
    };
    await fetchFormulationList(body).then((response) => {
      let newList = [];
      if (response && response.data && response.data.length > 0) {
        for (let index = 0; index < response.data.length; index++) {
          const item = response.data[index];
          newList.push({ value: item.stdlvl_cd, label: item.stdlvl_sym });
        }
        setFormulationList(newList);
        sessionStorage.setItem("Formulation", JSON.stringify(newList));
      }
    });
  };

  /*** 
  @purpose : Get pack list
  @Parameter : {}
  **/
  const getPackList = async () => {
    let body = {
      stdlvl_cd: "ALL",
    };
    await fetchPackagingList(body).then((response) => {
      let newList = [];
      if (response && response.data && response.data.length > 0) {
        for (let index = 0; index < response.data.length; index++) {
          const item = response.data[index];
          newList.push({ value: item.packlvl_cd, label: item.packlvl_sym });
        }
        setPackagingList(newList);
        sessionStorage.setItem("Pack", JSON.stringify(newList));
      }
    });
  };

  /*** 
    @purpose : Get maintenance time period
    @Parameter : {}
    **/
  const getMaintenanceTime = async () => {
    let body = {
      userType: "CA",
      report_type: "sellout-rotation",
    };
    await fetchMaintenanceList(body).then((response) => {
      setIsScreenLoading(false);
      setMaintenance(response && response.data && response.data.odsFlag);
    });
  };

  /*** 
  @purpose : Get target period
  @Parameter : {}
  **/
  const getTargetPeriod = async () => {
    sessionStorage.setItem("return_url", "");
    await fetchTargetPeriod("selloutRotationCA").then((response) => {
      setFromDate(
        response && response.from_date
          ? response.from_date.split("/").join("")
          : ""
      );
      setFromDateDisplay(
        response && response.from_date ? response.from_date : ""
      );
      setToDate(
        response && response.to_date ? response.to_date.split("/").join("") : ""
      );
      setToDateDisplay(response && response.to_date ? response.to_date : "");
      setProcessingDate(
        response && response.processing_date ? response.processing_date.split(" ")[0] : ""
      );
    });
  };

  /*** 
  @purpose : Get fixed month
  @Parameter : {}
  **/
  const getFixedMonth = async () => {
    await fetchFixedMonth().then((response) => {
      let month = "";
      let toMonth = "";
      let wholesaleMonth = "";
      let toWholesaleMonth = "";
      let date = response.fixed_month_japan_calendar.fromDate.split("/");
      let toDate = response.fixed_month_japan_calendar.toDate.split("/");
      let wholesaleDate =
        response.fixed_month_wholesaler_calendar.fromDate.split("/");
      let toWholesaleDate =
        response.fixed_month_wholesaler_calendar.toDate.split("/");
      if (date[1] === "01") month = "January";
      else if (date[1] === "02") month = "February";
      else if (date[1] === "03") month = "March";
      else if (date[1] === "04") month = "April";
      else if (date[1] === "05") month = "May";
      else if (date[1] === "06") month = "June";
      else if (date[1] === "07") month = "July";
      else if (date[1] === "08") month = "August";
      else if (date[1] === "09") month = "September";
      else if (date[1] === "10") month = "October";
      else if (date[1] === "11") month = "November";
      else if (date[1] === "12") month = "December";

      if (toDate[1] === "01") toMonth = "January";
      else if (toDate[1] === "02") toMonth = "February";
      else if (toDate[1] === "03") toMonth = "March";
      else if (toDate[1] === "04") toMonth = "April";
      else if (toDate[1] === "05") toMonth = "May";
      else if (toDate[1] === "06") toMonth = "June";
      else if (toDate[1] === "07") toMonth = "July";
      else if (toDate[1] === "08") toMonth = "August";
      else if (toDate[1] === "09") toMonth = "September";
      else if (toDate[1] === "10") toMonth = "October";
      else if (toDate[1] === "11") toMonth = "November";
      else if (toDate[1] === "12") toMonth = "December";
      setJPFromDateDisplay(month + " " + date[0]);
      setJPToDateDisplay(toMonth + " " + toDate[0]);

      if (wholesaleDate[1] === "01") wholesaleMonth = "January";
      else if (wholesaleDate[1] === "02") wholesaleMonth = "February";
      else if (wholesaleDate[1] === "03") wholesaleMonth = "March";
      else if (wholesaleDate[1] === "04") wholesaleMonth = "April";
      else if (wholesaleDate[1] === "05") wholesaleMonth = "May";
      else if (wholesaleDate[1] === "06") wholesaleMonth = "June";
      else if (wholesaleDate[1] === "07") wholesaleMonth = "July";
      else if (wholesaleDate[1] === "08") wholesaleMonth = "August";
      else if (wholesaleDate[1] === "09") wholesaleMonth = "September";
      else if (wholesaleDate[1] === "10") wholesaleMonth = "October";
      else if (wholesaleDate[1] === "11") wholesaleMonth = "November";
      else if (wholesaleDate[1] === "12") wholesaleMonth = "December";

      if (toWholesaleDate[1] === "01") toWholesaleMonth = "January";
      else if (toWholesaleDate[1] === "02") toWholesaleMonth = "February";
      else if (toWholesaleDate[1] === "03") toWholesaleMonth = "March";
      else if (toWholesaleDate[1] === "04") toWholesaleMonth = "April";
      else if (toWholesaleDate[1] === "05") toWholesaleMonth = "May";
      else if (toWholesaleDate[1] === "06") toWholesaleMonth = "June";
      else if (toWholesaleDate[1] === "07") toWholesaleMonth = "July";
      else if (toWholesaleDate[1] === "08") toWholesaleMonth = "August";
      else if (toWholesaleDate[1] === "09") toWholesaleMonth = "September";
      else if (toWholesaleDate[1] === "10") toWholesaleMonth = "October";
      else if (toWholesaleDate[1] === "11") toWholesaleMonth = "November";
      else if (toWholesaleDate[1] === "12") toWholesaleMonth = "December";
      setWholesaleFromDateDisplay(wholesaleMonth + " " + wholesaleDate[0]);
      setWholesaleToDateDisplay(toWholesaleMonth + " " + toWholesaleDate[0]);

      setWholesaleFromDate(wholesaleDate.join(""));
      setWholesaleToDate(toWholesaleDate.join(""));
      setJPFromDate(date.join(""));
      setJPToDate(toDate.join(""));
    });
  };

  const getProductTypeList = async () => {
    await fetchProductTypeList().then((response) => {
      let newList = [];
      for (let index = 0; index < response.length; index++) {
        const item = response[index];
        newList.push({ value: item.code, label: item.value });
      }
      setProductTypeList(newList);
    });
  };

  /*** 
  @purpose : Get target period
  @Parameter : {}
  **/
  const getHempLawList = async () => {
    await fetchHempLawList().then((response) => {
      let newList = [];
      for (let index = 0; index < response.length; index++) {
        const item = response[index];
        newList.push({ value: item.code, label: item.value });
      }
      setHempLawList(newList);
    });
  };

  /*** 
  @purpose : Close download message modal
  @Parameter : {}
  **/
  const handleCloseDownloadMessage = () => setShowDownloadMessage(false);

  /*** 
  @purpose : Get wholesaler group list
  @Parameter : {}
  **/
  const getWholesalerGroupList = async () => {
    let body = {
      org_level: 1,
    };
    await fetchWholesalerLevelList(body).then((response) => {
      if (response.data.length > 0) {
        let newList = [];
        for (let index = 0; index < response.data.length; index++) {
          const item = response.data[index];
          newList.push({
            value: item.whsl_grp_cd,
            label: item.whsl_grp_nm,
          });
        }
        setWholesalerGroupList(newList);
      }
    });
  };

  const handleWholeSalerGroupSelect = async (e) => {
    let list = [];
    list = [...selectedWholesalerGroupList, e];
    if (e === "ALL") {
      let list1 = list.filter((val) => val === "ALL");

      let body = {
        whsl_grp_cd: list1,
      };
      await fetchWholesalerLevelList(body).then((response) => {
        if (response.data.length > 0) {
          setWholesaleCorporationLoading(false);
          let newList = [];
          for (let index = 0; index < response.data.length; index++) {
            const item = response.data[index];
            newList.push({
              value: item.whsl_crp_cd,
              label: item.whsl_crp_nm,
            });
          }
          setWholesalerCorporationList(newList);
        }
      });
      setSelectedWholesalerGroupList(list1);
    } else if (e !== "ALL") {
      let list2 = list.filter((val) => val !== "ALL");

      let body = {
        whsl_grp_cd: list2,
      };
      await fetchWholesalerLevelList(body).then((response) => {
        if (response.data.length > 0) {
          setWholesaleCorporationLoading(false);
          let newList = [];
          for (let index = 0; index < response.data.length; index++) {
            const item = response.data[index];
            newList.push({
              value: item.whsl_crp_cd,
              label: item.whsl_crp_nm,
            });
          }
          setWholesalerCorporationList(newList);
        }
      });
      setSelectedWholesalerGroupList(list2);
    }
  };

  const handleWholeSalerCorporationSelect = async (e) => {
    let list = [];
    list = [...selectedWholesalerCorporationList, e];
    if (e === "ALL") {
      let list1 = list.filter((val) => val === "ALL");

      let body = {
        whsl_crp_cd: list1,
      };
      await fetchWholesalerLevelList(body).then((response) => {
        setWholesaleManagementSalesLoading(false);
        let newList = [];
        for (let index = 0; index < response.data.length; index++) {
          const item = response.data[index];
          newList.push({
            value: item.whsl_unf_dpt_cd,
            label: item.whsl_unf_dpt_nm,
          });
        }
        setWholesalerManagementList(newList);
      });
      setSelectedWholesalerCorporationList(list1);
    } else if (e !== "ALL") {
      let list2 = list.filter((val) => val !== "ALL");

      let body = {
        whsl_crp_cd: list2,
      };
      await fetchWholesalerLevelList(body).then((response) => {
        setWholesaleManagementSalesLoading(false);
        let newList = [];
        for (let index = 0; index < response.data.length; index++) {
          const item = response.data[index];
          newList.push({
            value: item.whsl_unf_dpt_cd,
            label: item.whsl_unf_dpt_nm,
          });
        }
        setWholesalerManagementList(newList);
      });
      setSelectedWholesalerCorporationList(list2);
    }
  };

  const handleWholeSalerManagementSelect = async (e) => {
    let list = [];
    list = [...selectedWholesalerManagementList, e];
    if (e === "ALL") {
      let list1 = list.filter((val) => val === "ALL");
      let body = {
        // org_level: 4,
        whsl_unf_dpt_cd: list1,
      };
      await fetchWholesalerLevelList(body).then((response) => {
        setWholesaleSalesLoading(false);
        let newList = [];
        for (let index = 0; index < response.data.length; index++) {
          const item = response.data[index];
          newList.push({
            value: item.whsl_dpt_cd,
            label: item.whsl_dpt_nm,
          });
        }
        setWholesalerSalesList(newList);
      });
      setSelectedWholesalerManagementList(list1);
    } else if (e !== "ALL") {
      let list2 = list.filter((val) => val !== "ALL");
      let body = {
        // org_level: 4,
        whsl_unf_dpt_cd: list2,
      };
      await fetchWholesalerLevelList(body).then((response) => {
        setWholesaleSalesLoading(false);
        let newList = [];
        for (let index = 0; index < response.data.length; index++) {
          const item = response.data[index];
          newList.push({
            value: item.whsl_dpt_cd,
            label: item.whsl_dpt_nm,
          });
        }
        setWholesalerSalesList(newList);
      });
      setSelectedWholesalerManagementList(list2);
    }
  };

  const handleWholeSalerSalesSelect = async (e) => {
    let list = [];
    list = [...selectedWholesalerSalesList, e];
    if (e === "ALL") {
      let list1 = list.filter((val) => val === "ALL");
      let body = {
        // org_level: 5,
        whsl_dpt_cd: list1,
      };
      await fetchWholesalerLevelList(body).then((response) => {
        setWholesaleBranchLoading(false);
        let newList = [];
        for (let index = 0; index < response.data.length; index++) {
          const item = response.data[index];
          newList.push({
            value: item.whsl_bra_cd,
            label: item.whsl_bra_nm,
          });
        }
        setWholesalerBranchList(newList);
      });
      setSelectedWholesalerSalesList(list1);
    } else if (e !== "ALL") {
      let list2 = list.filter((val) => val !== "ALL");
      let body = {
        // org_level: 5,
        whsl_dpt_cd: list2,
      };
      await fetchWholesalerLevelList(body).then((response) => {
        setWholesaleBranchLoading(false);
        let newList = [];
        for (let index = 0; index < response.data.length; index++) {
          const item = response.data[index];
          newList.push({
            value: item.whsl_bra_cd,
            label: item.whsl_bra_nm,
          });
        }
        setWholesalerBranchList(newList);
      });
      setSelectedWholesalerSalesList(list2);
    }
  };

  const handleWholeSalerBranchSelect = async (e) => {
    let list = [];
    list = [...selectedWholesalerBranchList, e];
    if (e === "ALL") {
      let list1 = list.filter((val) => val === "ALL");
      let body = {
        // org_level: 6,
        whsl_bra_cd: list1,
      };
      await fetchWholesalerLevelList(body).then((response) => {
        setWholesaleBranchSectionLoading(false);
        let newList = [];
        for (let index = 0; index < response.data.length; index++) {
          const item = response.data[index];
          newList.push({
            value: item.whsl_sct_cd,
            label: item.whsl_sct_nm,
          });
        }
        setWholesalerBranchSectionList(newList);
      });
      setSelectedWholesalerBranchList(list1);
    } else if (e !== "ALL") {
      let list2 = list.filter((val) => val !== "ALL");
      let body = {
        // org_level: 6,
        whsl_bra_cd: list2,
      };
      await fetchWholesalerLevelList(body).then((response) => {
        setWholesaleBranchSectionLoading(false);
        let newList = [];
        for (let index = 0; index < response.data.length; index++) {
          const item = response.data[index];
          newList.push({
            value: item.whsl_sct_cd,
            label: item.whsl_sct_nm,
          });
        }
        setWholesalerBranchSectionList(newList);
      });
      setSelectedWholesalerBranchList(list2);
    }
  };

  const handleWholeSalerBranchSectionSelect = async (e) => {
    let list = [];
    list = [...selectedWholesalerBranchSectionList, e];
    if (e === "ALL") {
      let list1 = list.filter((val) => val === "ALL");
      setSelectedWholesalerBranchSectionList(list1);
    } else if (e !== "ALL") {
      let list2 = list.filter((val) => val !== "ALL");
      setSelectedWholesalerBranchSectionList(list2);
    }
  };

  /*** 
  @purpose : Handle wholesaler group change
  @Parameter : {value}
  **/
  const handleWholesalerGroupChange = async (value) => {
    // let list = [];
    // if (value.length > 1 && value.includes("ALL")) {
    //   list = value.filter((val) => val !== "ALL");
    //   setSelectedWholesalerGroupList(list);
    // } else {
    //   setSelectedWholesalerGroupList(value);
    // }
    if (value.length < selectedWholesalerGroupList.length && value.length > 0) {
      setSelectedWholesalerGroupList(value);
      setWholesaleCorporationLoading(true);
      setSelectedWholesalerCorporationList([]);
      setSelectedWholesalerManagementList([]);
      setSelectedWholesalerSalesList([]);
      setSelectedWholesalerBranchList([]);
      setSelectedWholesalerBranchSectionList([]);
      let body = {
        whsl_grp_cd: value,
      };
      await fetchWholesalerLevelList(body).then((response) => {
        if (response.data.length > 0) {
          setWholesaleCorporationLoading(false);
          let newList = [];
          for (let index = 0; index < response.data.length; index++) {
            const item = response.data[index];
            newList.push({
              value: item.whsl_crp_cd,
              label: item.whsl_crp_nm,
            });
          }
          setWholesalerCorporationList(newList);
        }
      });
    } else if (value.length === 0) {
      setWholesaleCorporationLoading(false);
      setSelectedWholesalerGroupList([]);
      setSelectedWholesalerCorporationList([]);
      setSelectedWholesalerManagementList([]);
      setSelectedWholesalerSalesList([]);
      setSelectedWholesalerBranchList([]);
      setSelectedWholesalerBranchSectionList([]);
    }
  };

  /*** 
  @purpose : Handle wholesaler corporation change
  @Parameter : {value}
  **/
  const handleWholesalerCorporationChange = async (value) => {
    // let list = [];
    // if (value.length > 1 && value.includes("ALL")) {
    //   list = value.filter((val) => val !== "ALL");
    //   setSelectedWholesalerCorporationList(list);
    // } else {
    //   setSelectedWholesalerCorporationList(value);
    // }
    if (
      value.length < selectedWholesalerCorporationList.length &&
      value.length > 0
    ) {
      setSelectedWholesalerCorporationList(value);
      setWholesaleManagementSalesLoading(true);
      setSelectedWholesalerManagementList([]);
      setSelectedWholesalerSalesList([]);
      setSelectedWholesalerBranchList([]);
      setSelectedWholesalerBranchSectionList([]);
      let body = {
        whsl_crp_cd: value,
      };
      await fetchWholesalerLevelList(body).then((response) => {
        setWholesaleManagementSalesLoading(false);
        let newList = [];
        for (let index = 0; index < response.data.length; index++) {
          const item = response.data[index];
          newList.push({
            value: item.whsl_unf_dpt_cd,
            label: item.whsl_unf_dpt_nm,
          });
        }
        setWholesalerManagementList(newList);
      });
    } else if (value.length === 0) {
      setWholesaleManagementSalesLoading(false);
      setSelectedWholesalerCorporationList([]);
      setSelectedWholesalerManagementList([]);
      setSelectedWholesalerSalesList([]);
      setSelectedWholesalerBranchList([]);
      setSelectedWholesalerBranchSectionList([]);
    }
  };

  /*** 
  @purpose : Handle wholesaler management change
  @Parameter : {value}
  **/
  const handleWholesalerManagementChange = async (value) => {
    // let list = [];
    // if (value.length > 1 && value.includes("ALL")) {
    //   list = value.filter((val) => val !== "ALL");
    //   setSelectedWholesalerManagementList(list);
    // } else {
    //   setSelectedWholesalerManagementList(value);
    // }
    // setSelectedWholesalerManagementList(value);
    if (
      value.length < selectedWholesalerManagementList.length &&
      value.length > 0
    ) {
      setSelectedWholesalerManagementList(value);
      setWholesaleSalesLoading(true);
      setSelectedWholesalerSalesList([]);
      setSelectedWholesalerBranchList([]);
      setSelectedWholesalerBranchSectionList([]);
      let body = {
        // org_level: 4,
        whsl_unf_dpt_cd: value,
      };
      await fetchWholesalerLevelList(body).then((response) => {
        setWholesaleSalesLoading(false);
        let newList = [];
        for (let index = 0; index < response.data.length; index++) {
          const item = response.data[index];
          newList.push({
            value: item.whsl_dpt_cd,
            label: item.whsl_dpt_nm,
          });
        }
        setWholesalerSalesList(newList);
      });
    } else if (value.length === 0) {
      setWholesaleSalesLoading(false);
      setSelectedWholesalerManagementList([]);
      setSelectedWholesalerSalesList([]);
      setSelectedWholesalerBranchList([]);
      setSelectedWholesalerBranchSectionList([]);
    }
  };

  /*** 
  @purpose : Handle wholesaler sales change
  @Parameter : {value}
  **/
  const handleWholesalerSalesChange = async (value) => {
    // let list = [];
    // if (value.length > 1 && value.includes("ALL")) {
    //   list = value.filter((val) => val !== "ALL");
    //   setSelectedWholesalerSalesList(list);
    // } else {
    //   setSelectedWholesalerSalesList(value);
    // }
    // setSelectedWholesalerSalesList(value);
    if (value.length < selectedWholesalerSalesList.length && value.length > 0) {
      setSelectedWholesalerSalesList(value);
      setWholesaleBranchLoading(true);
      setSelectedWholesalerBranchList([]);
      setSelectedWholesalerBranchSectionList([]);
      let body = {
        // org_level: 5,
        whsl_dpt_cd: value,
      };
      await fetchWholesalerLevelList(body).then((response) => {
        setWholesaleBranchLoading(false);
        let newList = [];
        for (let index = 0; index < response.data.length; index++) {
          const item = response.data[index];
          newList.push({
            value: item.whsl_bra_cd,
            label: item.whsl_bra_nm,
          });
        }
        setWholesalerBranchList(newList);
      });
    } else if (value.length === 0) {
      setWholesaleBranchLoading(false);
      setSelectedWholesalerSalesList([]);
      setSelectedWholesalerBranchList([]);
      setSelectedWholesalerBranchSectionList([]);
    }
  };

  /*** 
  @purpose : Handle wholesaler branch change
  @Parameter : {value}
  **/
  const handleWholesalerBranchChange = async (value) => {
    // let list = [];
    // if (value.length > 1 && value.includes("ALL")) {
    //   list = value.filter((val) => val !== "ALL");
    //   setSelectedWholesalerBranchList(list);
    // } else {
    //   setSelectedWholesalerBranchList(value);
    // }
    // setSelectedWholesalerBranchList(value);
    if (
      value.length < selectedWholesalerBranchList.length &&
      value.length > 0
    ) {
      setSelectedWholesalerBranchList(value);
      setWholesaleBranchSectionLoading(true);
      setSelectedWholesalerBranchSectionList([]);
      let body = {
        // org_level: 6,
        whsl_bra_cd: value,
      };
      await fetchWholesalerLevelList(body).then((response) => {
        setWholesaleBranchSectionLoading(false);
        let newList = [];
        for (let index = 0; index < response.data.length; index++) {
          const item = response.data[index];
          newList.push({
            value: item.whsl_sct_cd,
            label: item.whsl_sct_nm,
          });
        }
        setWholesalerBranchSectionList(newList);
      });
    } else if (value.length === 0) {
      setWholesaleBranchSectionLoading(false);
      setSelectedWholesalerBranchList([]);
      setSelectedWholesalerBranchSectionList([]);
    }
  };

  /*** 
  @purpose : Handle wholesaler branch section change
  @Parameter : {value}
  **/
  const handleWholesalerBranchSectionChange = (value) => {
    // let list = [];
    // if (value.length > 1 && value.includes("ALL")) {
    //   list = value.filter((val) => val !== "ALL");
    //   setSelectedWholesalerBranchSectionList(list);
    // } else {
    //   setSelectedWholesalerBranchSectionList(value);
    // }
    if (value) {
      setSelectedWholesalerBranchSectionList(value);
    } else {
      setSelectedWholesalerBranchSectionList([]);
    }
  };

  const handleAllSelected = (e) => {
    setAllSelected(e.target.checked ? 1 : 0);
  };

  const handleDuration = (e) => {
    setDuration(e.target.value);
  };

  /*** 
  @purpose : Close user modal
  @Parameter : {}
  **/
  const handleCloseUserMessage = () => setShowUserMessage(false);

  const handleProductSelect = async (e) => {
    let list = [];
    list = [...selectedProducts, e];
    if (e === "ALL") {
      let list1 = list.filter((val) => val === "ALL");

      let body = {
        prdctlvl_cd: list1,
      };
      await fetchMarketAuthorizationList(body).then((response) => {
        setMarketLoading(false);
        let newList = [];
        for (let index = 0; index < response.data.length; index++) {
          const item = response.data[index];
          newList.push({ value: item.aprlvl_cd, label: item.aprlvl_sym });
        }
        setMarketAuthList(newList);
      });
      setSelectedProducts(list1);
    } else if (e !== "ALL") {
      let list2 = list.filter((val) => val !== "ALL");

      let body = {
        prdctlvl_cd: list2,
      };
      await fetchMarketAuthorizationList(body).then((response) => {
        setMarketLoading(false);
        let newList = [];
        for (let index = 0; index < response.data.length; index++) {
          const item = response.data[index];
          newList.push({ value: item.aprlvl_cd, label: item.aprlvl_sym });
        }
        setMarketAuthList(newList);
      });
      setSelectedProducts(list2);
    }
  };

  const handleMarketAuthSelect = async (e) => {
    let list = [];
    list = [...selectedMarketAuth, e];
    if (e === "ALL") {
      let list1 = list.filter((val) => val === "ALL");
      let body = {
        aprlvl_cd: list1,
      };
      await fetchFormList(body).then((response) => {
        setFormLoading(false);
        let newList = [];
        for (let index = 0; index < response.data.length; index++) {
          const item = response.data[index];
          newList.push({ value: item.frmlvl_cd, label: item.frmlvl_sym });
        }
        setFormList(newList);
      });

      setSelectedMarketAuth(list1);
    } else if (e !== "ALL") {
      let list2 = list.filter((val) => val !== "ALL");
      let body = {
        aprlvl_cd: list2,
      };
      await fetchFormList(body).then((response) => {
        setFormLoading(false);
        let newList = [];
        for (let index = 0; index < response.data.length; index++) {
          const item = response.data[index];
          newList.push({ value: item.frmlvl_cd, label: item.frmlvl_sym });
        }
        setFormList(newList);
      });

      setSelectedMarketAuth(list2);
    }
  };

  const handleFormSelect = async (e) => {
    let list = [];
    list = [...selectedForm, e];
    if (e === "ALL") {
      let list1 = list.filter((val) => val === "ALL");
      let body = {
        frmlvl_cd: list1,
      };
      await fetchFormulationList(body).then((response) => {
        setFormulationLoading(false);
        let newList = [];
        for (let index = 0; index < response.data.length; index++) {
          const item = response.data[index];
          newList.push({ value: item.stdlvl_cd, label: item.stdlvl_sym });
        }
        setFormulationList(newList);
      });

      setSelectedForm(list1);
    } else if (e !== "ALL") {
      let list2 = list.filter((val) => val !== "ALL");

      let body = {
        frmlvl_cd: list2,
      };
      await fetchFormulationList(body).then((response) => {
        setFormulationLoading(false);
        let newList = [];
        for (let index = 0; index < response.data.length; index++) {
          const item = response.data[index];
          newList.push({ value: item.stdlvl_cd, label: item.stdlvl_sym });
        }
        setFormulationList(newList);
      });
      setSelectedForm(list2);
    }
  };

  const handleFormulationSelect = async (e) => {
    let list = [];
    list = [...selectedFormulation, e];
    if (e === "ALL") {
      let list1 = list.filter((val) => val === "ALL");

      let body = {
        stdlvl_cd: list1,
      };
      await fetchPackagingList(body).then((response) => {
        setPackLoading(false);
        let newList = [];
        for (let index = 0; index < response.data.length; index++) {
          const item = response.data[index];
          newList.push({ value: item.packlvl_cd, label: item.packlvl_sym });
        }
        setPackagingList(newList);
      });
      setSelectedFormulation(list1);
    } else if (e !== "ALL") {
      let list2 = list.filter((val) => val !== "ALL");

      let body = {
        stdlvl_cd: list2,
      };
      await fetchPackagingList(body).then((response) => {
        setPackLoading(false);
        let newList = [];
        for (let index = 0; index < response.data.length; index++) {
          const item = response.data[index];
          newList.push({ value: item.packlvl_cd, label: item.packlvl_sym });
        }
        setPackagingList(newList);
      });
      setSelectedFormulation(list2);
    }
  };

  const handlePackSelect = (e, value) => {
    let list = [];
    list = [...selectedPackaging, e];
    if (e === "ALL") {
      let list1 = list.filter((val) => val === "ALL");

      setSelectedPackaging(list1);
    } else if (e !== "ALL") {
      let list2 = list.filter((val) => val !== "ALL");

      setSelectedPackaging(list2);
    }
  };

  /*** 
  @purpose : Handle product change
  @Parameter : {value}
  **/
  const handleProductChange = async (value) => {
    setMarketLoading(true);
    if (value.length < selectedProducts.length && value.length > 0) {
      setSelectedProducts(value);
      setSelectedMarketAuth([]);
      setSelectedForm([]);
      setSelectedFormulation([]);
      setSelectedPackaging([]);
      let body = {
        prdctlvl_cd: value,
      };
      await fetchMarketAuthorizationList(body).then((response) => {
        setMarketLoading(false);
        let newList = [];
        for (let index = 0; index < response.data.length; index++) {
          const item = response.data[index];
          newList.push({ value: item.aprlvl_cd, label: item.aprlvl_sym });
        }
        setMarketAuthList(newList);
      });
    } else if (value.length === 0) {
      setMarketLoading(false);
      setSelectedProducts([]);
      setSelectedMarketAuth([]);
      setSelectedForm([]);
      setSelectedFormulation([]);
      setSelectedPackaging([]);
    }
  };

  /*** 
  @purpose : Handle market authorization change
  @Parameter : {value}
  **/
  const handleMarketAuthorizationChange = async (value) => {
    setFormLoading(true);
    if (value.length < selectedMarketAuth.length && value.length > 0) {
      setSelectedMarketAuth(value);
      setSelectedForm([]);
      setSelectedFormulation([]);
      setSelectedPackaging([]);
      let body = {
        aprlvl_cd: selectedProducts,
      };
      await fetchFormList(body).then((response) => {
        setFormLoading(false);
        let newList = [];
        for (let index = 0; index < response.data.length; index++) {
          const item = response.data[index];
          newList.push({ value: item.frmlvl_cd, label: item.frmlvl_sym });
        }
        setFormList(newList);
      });
    } else if (value.length === 0) {
      setFormLoading(false);
      setSelectedMarketAuth([]);
      setSelectedForm([]);
      setSelectedFormulation([]);
      setSelectedPackaging([]);
    }
  };

  /*** 
  @purpose : Handle form change
  @Parameter : {value}
  **/
  const handleFormChange = async (value) => {
    setFormulationLoading(true);
    if (value.length < selectedForm.length && value.length > 0) {
      setSelectedForm(value);
      setSelectedFormulation([]);
      setSelectedPackaging([]);
      let body = {
        frmlvl_cd: selectedProducts,
      };
      await fetchFormulationList(body).then((response) => {
        setFormulationLoading(false);
        let newList = [];
        for (let index = 0; index < response.data.length; index++) {
          const item = response.data[index];
          newList.push({ value: item.stdlvl_cd, label: item.stdlvl_sym });
        }
        setFormulationList(newList);
      });
    } else if (value.length === 0) {
      setFormulationLoading(false);
      setSelectedForm([]);
      setSelectedFormulation([]);
      setSelectedPackaging([]);
    }
  };

  /*** 
  @purpose : Handle formulation change
  @Parameter : {value}
  **/
  const handleFormulationChange = async (value) => {
    setPackLoading(true);
    if (value.length < selectedFormulation.length && value.length > 0) {
      setSelectedFormulation(value);
      setSelectedPackaging([]);
      let body = {
        stdlvl_cd: value,
      };
      await fetchPackagingList(body).then((response) => {
        setPackLoading(false);
        let newList = [];
        for (let index = 0; index < response.data.length; index++) {
          const item = response.data[index];
          newList.push({ value: item.packlvl_cd, label: item.packlvl_sym });
        }
        setPackagingList(newList);
      });
    } else if (value.length === 0) {
      setPackLoading(false);
      setSelectedFormulation([]);
      setSelectedPackaging([]);
    }
  };

  /*** 
  @purpose : Handle packaging change
  @Parameter : {value}
  **/
  const handlePackagingChange = (value) => {
    setSelectedPackaging(value);
  };

  /*** 
  @purpose : Handle hundred floor change
  @Parameter : {value}
  **/
  const handleHundredFloorChange = (value) => {
    setHundredFloorId(value.value);
  };

  /*** 
  @purpose : Handle two hundred change
  @Parameter : {value}
  **/

  const handleTwoHundredFloorChange = (value) => {
    setTwoHundredFloorId(value.value);
  };

  /*** 
  @purpose : Handle product type change
  @Parameter : {value}
  **/
  const handleProductTypeChange = (value) => {
    setProductType(value.value);
  };

  const handleFromYear = (date) => {
    var fullDate = new Date(date),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    var dt = [fullDate.getFullYear(), mnth, day].join("");
    var time = fullDate.toLocaleTimeString();
    setFromDate(dt);
    setFromDateDisplay([fullDate.getFullYear(), mnth, day].join("/"));
  };

  const handleToYear = (date) => {
    var fullDate = new Date(date),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    var dt = [fullDate.getFullYear(), mnth, day].join("");
    var time = fullDate.toLocaleTimeString();
    setToDate(dt);
    setToDateDisplay([fullDate.getFullYear(), mnth, day].join("/"));
  };

  const handlePrefectureChange = async (value) => {
    if (value.length > 0) {
      setCityLoading(true);
      setSelectedPrefecture(value);
      let body = {
        prefecture_code: value,
      };
      await fetchCountyList(body).then((response) => {
        setCityLoading(false);
        if (response.data) {
          let newList = [];
          if (response.data.length > 0) {
            for (let index = 0; index < response.data.length; index++) {
              const item = response.data[index];
              newList.push({
                value: item.county_code,
                label: item.county_name_local,
              });
            }
          } else {
            newList = [];
          }
          setCountyList(newList);
        }
      });
    } else if (value.length === 0) {
      setCityLoading(false);
      setSelectedPrefecture([]);
      setSelectedCounty([]);
    }
  };

  const handleCountyChange = (value) => {
    setSelectedCounty(value);
  };

  const handleSalesCompanyChange = (e) => {
    setSalesCompany(e.target.value);
  };

  const handleSortItem = (e) => {
    setSortItem(e.target.value);
  };

  const handleNumericalItem = (e) => {
    setNumericalItem(e.target.value);
  };

  const handeHempLawChange = (value) => {
    setSelectedHempLaw(value);
  };

  /*** 
    @purpose : Change route
    @Parameter : {e, page}
    **/
  const changeRoute = (e, page) => {
    e.stopPropagation();
    e.nativeEvent.stopImmediatePropagation();
    navigate(page,{
      state: { page: "selloutWholesaler" },
    });
  };

  const getSelloutRotationWholesalerReport = () => {
    allSelected === 1
      ? setShowUserMessage(true)
      : handleSelloutRotationReport();
  };

  const handleSelloutRotationReport = async () => {
    setShowUserMessage(false);
    setLoading(true);
    setNoData(false);
    setReportListing([]);
    setHeaders([]);
    let employeeList = [];
    details.map((emp) => employeeList.push(emp.wwid));
    if (duration === "fixedMonthJP") {
      let body = {
        employee_wwid:
          details && details.length > 0 ? employeeList : [personInCharge],
        employee_all_select: allSelected,
        wholesaler_group:
          selectedWholesalerGroupList.length > 0
            ? selectedWholesalerGroupList
            : "ALL",
        Wholesaler_Company_Code:
          selectedWholesalerCorporationList.length > 0
            ? selectedWholesalerCorporationList
            : "ALL",
        wholesale_management_sales_department:
          selectedWholesalerManagementList.length > 0
            ? selectedWholesalerManagementList
            : "ALL",
        wholesale_sales_department:
          selectedWholesalerSalesList.length > 0
            ? selectedWholesalerSalesList
            : "ALL",
        wholesale_branch:
          selectedWholesalerBranchList.length > 0
            ? selectedWholesalerBranchList
            : "ALL",
        wholesale_branch_section:
          selectedWholesalerBranchSectionList.length > 0
            ? selectedWholesalerBranchSectionList
            : "ALL",
        "100_bed": hundredFloorId,
        "200_bed": twoHundredFloorId,
        product_l: selectedProducts.length > 0 ? selectedProducts : "ALL",
        market_authorization_l:
          selectedMarketAuth.length > 0 ? selectedMarketAuth : "ALL",
        form_l: selectedForm.length > 0 ? selectedForm : "ALL",
        formulation_l:
          selectedFormulation.length > 0 ? selectedFormulation : "ALL",
        pack_l: selectedPackaging.length > 0 ? selectedPackaging : "ALL",
        product_type: productType.length > 0 ? productType : "ALL",
        prefecture: selectedPrefecture.length > 0 ? selectedPrefecture : "ALL",
        county: selectedCounty.length > 0 ? selectedCounty : "ALL",
        hemp_law_target_classification:
          selectedHempLaw.length > 0 ? selectedHempLaw : "ALL",
        company_copromotion_flg: salesCompany,
        drug_price: numericalItem === "salesAmount" ? 1 : 0,
        number_of_boxes: numericalItem === "packageQuantity" ? 1 : 0,
        received_and_paid_quantity: numericalItem === "bulkQuantity" ? 1 : 0,
        partition_amount:
          numericalItem === "salesAmountByWholesalerPurchasePrice" ? 1 : 0,
        actual_delivery_amount:
          numericalItem === "salesAmountByCustomerPurchasePrice" ? 1 : 0,
        sort_items: sortItem,
        fixed_month_japan_calendar: 1,
        fromDate: jpFromDate,
        toDate: jpToDate,
        userType: "CA",
        sort_field: "",
        sort_order: "",
        limit: LOAD_MORE_PAGE_SIZE,
      };
      await getSelloutRotationCAReportList(body).then((response) => {
        if (response.success === true && response.data.data.length > 0) {
          setReportListing(response && response.data && response.data.data);
          setHeaders(response.data.header);
          let count = response.data.total_count.split(",");
          setTotal(parseInt(count.join("")));
          setLimit(LOAD_MORE_PAGE_SIZE * 2);
          setShowUserMessage(false);
          setNoData(false);
          setLoading(false);
        } else if (
          (response.success === true && response.data.data.length === 0) ||
          response.success === false
        ) {
          setNoData(true);
          setLoading(false);
          setReportListing([]);
          setTotal();
        }
      });
    } else if (duration === "fixedMonthWholesale") {
      let body = {
        employee_wwid:
          details && details.length > 0 ? employeeList : [personInCharge],
        employee_all_select: allSelected,
        wholesaler_group:
          selectedWholesalerGroupList.length > 0
            ? selectedWholesalerGroupList
            : "ALL",
        Wholesaler_Company_Code:
          selectedWholesalerCorporationList.length > 0
            ? selectedWholesalerCorporationList
            : "ALL",
        wholesale_management_sales_department:
          selectedWholesalerManagementList.length > 0
            ? selectedWholesalerManagementList
            : "ALL",
        wholesale_sales_department:
          selectedWholesalerSalesList.length > 0
            ? selectedWholesalerSalesList
            : "ALL",
        wholesale_branch:
          selectedWholesalerBranchList.length > 0
            ? selectedWholesalerBranchList
            : "ALL",
        wholesale_branch_section:
          selectedWholesalerBranchSectionList.length > 0
            ? selectedWholesalerBranchSectionList
            : "ALL",
        "100_bed": hundredFloorId,
        "200_bed": twoHundredFloorId,
        product_l: selectedProducts.length > 0 ? selectedProducts : "ALL",
        market_authorization_l:
          selectedMarketAuth.length > 0 ? selectedMarketAuth : "ALL",
        form_l: selectedForm.length > 0 ? selectedForm : "ALL",
        formulation_l:
          selectedFormulation.length > 0 ? selectedFormulation : "ALL",
        pack_l: selectedPackaging.length > 0 ? selectedPackaging : "ALL",
        product_type: productType.length > 0 ? productType : "ALL",
        prefecture: selectedPrefecture.length > 0 ? selectedPrefecture : "ALL",
        county: selectedCounty.length > 0 ? selectedCounty : "ALL",
        hemp_law_target_classification:
          selectedHempLaw.length > 0 ? selectedHempLaw : "ALL",
        company_copromotion_flg: salesCompany,
        drug_price: numericalItem === "salesAmount" ? 1 : 0,
        number_of_boxes: numericalItem === "packageQuantity" ? 1 : 0,
        received_and_paid_quantity: numericalItem === "bulkQuantity" ? 1 : 0,
        partition_amount:
          numericalItem === "salesAmountByWholesalerPurchasePrice" ? 1 : 0,
        actual_delivery_amount:
          numericalItem === "salesAmountByCustomerPurchasePrice" ? 1 : 0,
        sort_items: sortItem,
        fixed_month_wholesaler_calendar: 1,
        fromDate: wholesaleFromDate,
        toDate: wholesaleToDate,
        userType: "CA",
        sort_field: "",
        sort_order: "",
        limit: LOAD_MORE_PAGE_SIZE,
      };
      await getSelloutRotationCAReportList(body).then((response) => {
        if (response.success === true && response.data.data.length > 0) {
          setReportListing(response && response.data && response.data.data);
          setHeaders(response.data.header);
          let count = response.data.total_count.split(",");
          setTotal(parseInt(count.join("")));
          setLimit(LOAD_MORE_PAGE_SIZE * 2);
          setShowUserMessage(false);
          setNoData(false);
          setLoading(false);
        } else if (
          (response.success === true && response.data.data.length === 0) ||
          response.success === false
        ) {
          setNoData(true);
          setLoading(false);
          setReportListing([]);
          setTotal();
        }
      });
    } else if (duration === "targetPeriod") {
      let body = {
        employee_wwid:
          details && details.length > 0 ? employeeList : [personInCharge],
        employee_all_select: allSelected,
        wholesaler_group:
          selectedWholesalerGroupList.length > 0
            ? selectedWholesalerGroupList
            : "ALL",
        Wholesaler_Company_Code:
          selectedWholesalerCorporationList.length > 0
            ? selectedWholesalerCorporationList
            : "ALL",
        wholesale_management_sales_department:
          selectedWholesalerManagementList.length > 0
            ? selectedWholesalerManagementList
            : "ALL",
        wholesale_sales_department:
          selectedWholesalerSalesList.length > 0
            ? selectedWholesalerSalesList
            : "ALL",
        wholesale_branch:
          selectedWholesalerBranchList.length > 0
            ? selectedWholesalerBranchList
            : "ALL",
        wholesale_branch_section:
          selectedWholesalerBranchSectionList.length > 0
            ? selectedWholesalerBranchSectionList
            : "ALL",
        "100_bed": hundredFloorId,
        "200_bed": twoHundredFloorId,
        product_l: selectedProducts.length > 0 ? selectedProducts : "ALL",
        market_authorization_l:
          selectedMarketAuth.length > 0 ? selectedMarketAuth : "ALL",
        form_l: selectedForm.length > 0 ? selectedForm : "ALL",
        formulation_l:
          selectedFormulation.length > 0 ? selectedFormulation : "ALL",
        pack_l: selectedPackaging.length > 0 ? selectedPackaging : "ALL",
        product_type: productType.length > 0 ? productType : "ALL",
        prefecture: selectedPrefecture.length > 0 ? selectedPrefecture : "ALL",
        county: selectedCounty.length > 0 ? selectedCounty : "ALL",
        hemp_law_target_classification:
          selectedHempLaw.length > 0 ? selectedHempLaw : "ALL",
        company_copromotion_flg: salesCompany,
        drug_price: numericalItem === "salesAmount" ? 1 : 0,
        number_of_boxes: numericalItem === "packageQuantity" ? 1 : 0,
        received_and_paid_quantity: numericalItem === "bulkQuantity" ? 1 : 0,
        partition_amount:
          numericalItem === "salesAmountByWholesalerPurchasePrice" ? 1 : 0,
        actual_delivery_amount:
          numericalItem === "salesAmountByCustomerPurchasePrice" ? 1 : 0,
        sort_items: sortItem,
        target_period: 1,
        fromDate: fromDate,
        toDate: toDate,
        userType: "CA",
        sort_field: "",
        sort_order: "",
        limit: LOAD_MORE_PAGE_SIZE,
      };
      await getSelloutRotationCAReportList(body).then((response) => {
        if (response.success === true && response.data.data.length > 0) {
          setReportListing(response && response.data && response.data.data);
          setHeaders(response.data.header);
          let count = response.data.total_count.split(",");
          setTotal(parseInt(count.join("")));
          setLimit(LOAD_MORE_PAGE_SIZE * 2);
          setShowUserMessage(false);
          setNoData(false);
          setLoading(false);
          let months = Object.keys(response?.data?.data[0]?.monthlydata);
          let years = [];
          let firstMonth = months[0];

          years = Object.keys(response.data.data[0].monthlydata[firstMonth]);
          setTargetPeriodYearList(years);
        } else if (
          (response.success === true && response.data.data.length === 0) ||
          response.success === false
        ) {
          setNoData(true);
          setLoading(false);
          setReportListing([]);
          setTotal();
          setTargetPeriodYearList([]);
        }
      });
    }
  };

  const handleExcelDownload = async () => {
    setExcelLoading(true);
    let employeeList = [];
    details.map((emp) => employeeList.push(emp.wwid));
    if (duration === "fixedMonthJP") {
      let body = {
        employee_wwid:
          details && details.length > 0 ? employeeList : [personInCharge],
        employee_all_select: allSelected,
        wholesaler_group:
          selectedWholesalerGroupList.length > 0
            ? selectedWholesalerGroupList
            : "ALL",
        Wholesaler_Company_Code:
          selectedWholesalerCorporationList.length > 0
            ? selectedWholesalerCorporationList
            : "ALL",
        wholesale_management_sales_department:
          selectedWholesalerManagementList.length > 0
            ? selectedWholesalerManagementList
            : "ALL",
        wholesale_sales_department:
          selectedWholesalerSalesList.length > 0
            ? selectedWholesalerSalesList
            : "ALL",
        wholesale_branch:
          selectedWholesalerBranchList.length > 0
            ? selectedWholesalerBranchList
            : "ALL",
        wholesale_branch_section:
          selectedWholesalerBranchSectionList.length > 0
            ? selectedWholesalerBranchSectionList
            : "ALL",
        "100_bed": hundredFloorId,
        "200_bed": twoHundredFloorId,
        product_l: selectedProducts.length > 0 ? selectedProducts : "ALL",
        market_authorization_l:
          selectedMarketAuth.length > 0 ? selectedMarketAuth : "ALL",
        form_l: selectedForm.length > 0 ? selectedForm : "ALL",
        formulation_l:
          selectedFormulation.length > 0 ? selectedFormulation : "ALL",
        pack_l: selectedPackaging.length > 0 ? selectedPackaging : "ALL",
        product_type: productType.length > 0 ? productType : "ALL",
        prefecture: selectedPrefecture.length > 0 ? selectedPrefecture : "ALL",
        county: selectedCounty.length > 0 ? selectedCounty : "ALL",
        hemp_law_target_classification:
          selectedHempLaw.length > 0 ? selectedHempLaw : "ALL",
        company_copromotion_flg: salesCompany,
        drug_price: numericalItem === "salesAmount" ? 1 : 0,
        number_of_boxes: numericalItem === "packageQuantity" ? 1 : 0,
        received_and_paid_quantity: numericalItem === "bulkQuantity" ? 1 : 0,
        partition_amount:
          numericalItem === "salesAmountByWholesalerPurchasePrice" ? 1 : 0,
        actual_delivery_amount:
          numericalItem === "salesAmountByCustomerPurchasePrice" ? 1 : 0,
        sort_items: sortItem,
        fixed_month_japan_calendar: 1,
        fromDate: jpFromDate,
        toDate: jpToDate,
        userType: "CA",
        view_type: "download",
        sort_field: sortField,
        sort_order: sortOrder,
        batch_size: 10000,
      };
      await getSelloutRotationCAReportList(body).then((response) => {
        setExcelLoading(false);
        if (Object.keys(response).includes("file")) {
          var currentDate = new Date();
          var fullDate = new Date(currentDate),
            mnth = ("0" + (currentDate.getMonth() + 1)).slice(-2),
            day = ("0" + currentDate.getDate()).slice(-2),
            hr = ("0" + currentDate.getHours()).slice(-2),
            min = ("0" + currentDate.getMinutes()).slice(-2),
            sec = ("0" + currentDate.getSeconds()).slice(-2);
          var dt = [fullDate.getFullYear(), mnth, day].join("");
          var time = [hr, min, sec].join("");
          let fileName =
            "sellout_rotation_report_ca_" + dt + "_" + time + ".xlsx";
          let file = response.file;
          fetch(file)
            .then((res) => res.blob())
            .then((data) => {
              const url = window.URL.createObjectURL(new Blob([data]));
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", fileName);
              link.click();
            });
        } else if (Object.keys(response).includes("data")) {
          setDownloadMessage(response.data);
          setShowDownloadMessage(true);
        }
      });
    } else if (duration === "fixedMonthWholesale") {
      let body = {
        employee_wwid:
          details && details.length > 0 ? employeeList : [personInCharge],
        employee_all_select: allSelected,
        wholesaler_group:
          selectedWholesalerGroupList.length > 0
            ? selectedWholesalerGroupList
            : "ALL",
        Wholesaler_Company_Code:
          selectedWholesalerCorporationList.length > 0
            ? selectedWholesalerCorporationList
            : "ALL",
        wholesale_management_sales_department:
          selectedWholesalerManagementList.length > 0
            ? selectedWholesalerManagementList
            : "ALL",
        wholesale_sales_department:
          selectedWholesalerSalesList.length > 0
            ? selectedWholesalerSalesList
            : "ALL",
        wholesale_branch:
          selectedWholesalerBranchList.length > 0
            ? selectedWholesalerBranchList
            : "ALL",
        wholesale_branch_section:
          selectedWholesalerBranchSectionList.length > 0
            ? selectedWholesalerBranchSectionList
            : "ALL",
        "100_bed": hundredFloorId,
        "200_bed": twoHundredFloorId,
        product_l: selectedProducts.length > 0 ? selectedProducts : "ALL",
        market_authorization_l:
          selectedMarketAuth.length > 0 ? selectedMarketAuth : "ALL",
        form_l: selectedForm.length > 0 ? selectedForm : "ALL",
        formulation_l:
          selectedFormulation.length > 0 ? selectedFormulation : "ALL",
        pack_l: selectedPackaging.length > 0 ? selectedPackaging : "ALL",
        product_type: productType.length > 0 ? productType : "ALL",
        prefecture: selectedPrefecture.length > 0 ? selectedPrefecture : "ALL",
        county: selectedCounty.length > 0 ? selectedCounty : "ALL",
        hemp_law_target_classification:
          selectedHempLaw.length > 0 ? selectedHempLaw : "ALL",
        company_copromotion_flg: salesCompany,
        drug_price: numericalItem === "salesAmount" ? 1 : 0,
        number_of_boxes: numericalItem === "packageQuantity" ? 1 : 0,
        received_and_paid_quantity: numericalItem === "bulkQuantity" ? 1 : 0,
        partition_amount:
          numericalItem === "salesAmountByWholesalerPurchasePrice" ? 1 : 0,
        actual_delivery_amount:
          numericalItem === "salesAmountByCustomerPurchasePrice" ? 1 : 0,
        sort_items: sortItem,
        fixed_month_wholesaler_calendar: 1,
        fromDate: wholesaleFromDate,
        toDate: wholesaleToDate,
        userType: "CA",
        view_type: "download",
        sort_field: sortField,
        sort_order: sortOrder,
        batch_size: 10000,
      };
      await getSelloutRotationCAReportList(body).then((response) => {
        if (Object.keys(response).includes("file")) {
          // window.location.href = response.file
          var currentDate = new Date();
          var fullDate = new Date(currentDate),
            mnth = ("0" + (currentDate.getMonth() + 1)).slice(-2),
            day = ("0" + currentDate.getDate()).slice(-2),
            hr = ("0" + currentDate.getHours()).slice(-2),
            min = ("0" + currentDate.getMinutes()).slice(-2),
            sec = ("0" + currentDate.getSeconds()).slice(-2);
          var dt = [fullDate.getFullYear(), mnth, day].join("");
          var time = [hr, min, sec].join("");
          let fileName =
            "sellout_rotation_report_ca_" + dt + "_" + time + ".xls";
          let file = response.file;
          fetch(file)
            .then((res) => res.blob())
            .then((data) => {
              const url = window.URL.createObjectURL(new Blob([data]));
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", fileName);
              link.click();
            });
        } else if (Object.keys(response).includes("data")) {
          setDownloadMessage(response.data);
          setShowDownloadMessage(true);
        }
      });
    } else if (duration === "targetPeriod") {
      let body = {
        employee_wwid:
          details && details.length > 0 ? employeeList : [personInCharge],
        employee_all_select: allSelected,
        wholesaler_group:
          selectedWholesalerGroupList.length > 0
            ? selectedWholesalerGroupList
            : "ALL",
        wholesaler_Company_Code:
          selectedWholesalerCorporationList.length > 0
            ? selectedWholesalerCorporationList
            : "ALL",
        wholesale_management_sales_department:
          selectedWholesalerManagementList.length > 0
            ? selectedWholesalerManagementList
            : "ALL",
        wholesale_sales_department:
          selectedWholesalerSalesList.length > 0
            ? selectedWholesalerSalesList
            : "ALL",
        wholesale_branch:
          selectedWholesalerBranchList.length > 0
            ? selectedWholesalerBranchList
            : "ALL",
        wholesale_branch_section:
          selectedWholesalerBranchSectionList.length > 0
            ? selectedWholesalerBranchSectionList
            : "ALL",
        "100_bed": hundredFloorId,
        "200_bed": twoHundredFloorId,
        product_l: selectedProducts.length > 0 ? selectedProducts : "ALL",
        market_authorization_l:
          selectedMarketAuth.length > 0 ? selectedMarketAuth : "ALL",
        form_l: selectedForm.length > 0 ? selectedForm : "ALL",
        formulation_l:
          selectedFormulation.length > 0 ? selectedFormulation : "ALL",
        pack_l: selectedPackaging.length > 0 ? selectedPackaging : "ALL",
        product_type: productType.length > 0 ? productType : "ALL",
        prefecture: selectedPrefecture.length > 0 ? selectedPrefecture : "ALL",
        county: selectedCounty.length > 0 ? selectedCounty : "ALL",
        hemp_law_target_classification:
          selectedHempLaw.length > 0 ? selectedHempLaw : "ALL",
        company_copromotion_flg: salesCompany,
        drug_price: numericalItem === "salesAmount" ? 1 : 0,
        number_of_boxes: numericalItem === "packageQuantity" ? 1 : 0,
        received_and_paid_quantity: numericalItem === "bulkQuantity" ? 1 : 0,
        partition_amount:
          numericalItem === "salesAmountByWholesalerPurchasePrice" ? 1 : 0,
        actual_delivery_amount:
          numericalItem === "salesAmountByCustomerPurchasePrice" ? 1 : 0,
        sort_items: sortItem,
        target_period: 1,
        fromDate: fromDate,
        toDate: toDate,
        userType: "CA",
        view_type: "download",
        sort_field: sortField,
        sort_order: sortOrder,
        batch_size: 10000,
      };
      await getSelloutRotationCAReportList(body).then((response) => {
        if (Object.keys(response).includes("file")) {
          // window.location.href = response.file
          var currentDate = new Date();
          var fullDate = new Date(currentDate),
            mnth = ("0" + (currentDate.getMonth() + 1)).slice(-2),
            day = ("0" + currentDate.getDate()).slice(-2),
            hr = ("0" + currentDate.getHours()).slice(-2),
            min = ("0" + currentDate.getMinutes()).slice(-2),
            sec = ("0" + currentDate.getSeconds()).slice(-2);
          var dt = [fullDate.getFullYear(), mnth, day].join("");
          var time = [hr, min, sec].join("");
          let fileName =
            "sellout_rotation_report_ca_" + dt + "_" + time + ".xls";
          let file = response.file;
          fetch(file)
            .then((res) => res.blob())
            .then((data) => {
              const url = window.URL.createObjectURL(new Blob([data]));
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", fileName);
              link.click();
            });
        } else if (Object.keys(response).includes("data")) {
          setDownloadMessage(response.data);
          setShowDownloadMessage(true);
        }
      });
    }
  };

  // const handleContainerOnBottom = async () => {
  //   if (reportListing.length > 0) {
  //     setLazyLoading(true);
  //     let employeeList = [];
  //     details.map((emp) => employeeList.push(emp.wwid));
  //     if (duration === "fixedMonthJP") {
  //       let body = {
  //         employee_wwid:
  //           details && details.length > 0 ? employeeList : [personInCharge],
  //         employee_all_select: allSelected,
  //         wholesaler_group:
  //           selectedWholesalerGroupList.length > 0
  //             ? selectedWholesalerGroupList
  //             : "ALL",
  //         wholesaler_Company_Code:
  //           selectedWholesalerCorporationList.length > 0
  //             ? selectedWholesalerCorporationList
  //             : "ALL",
  //         wholesale_management_sales_department:
  //           selectedWholesalerManagementList.length > 0
  //             ? selectedWholesalerManagementList
  //             : "ALL",
  //         wholesale_sales_department:
  //           selectedWholesalerSalesList.length > 0
  //             ? selectedWholesalerSalesList
  //             : "ALL",
  //         wholesale_branch:
  //           selectedWholesalerBranchList.length > 0
  //             ? selectedWholesalerBranchList
  //             : "ALL",
  //         wholesale_branch_section:
  //           selectedWholesalerBranchSectionList.length > 0
  //             ? selectedWholesalerBranchSectionList
  //             : "ALL",
  //         "100_bed": hundredFloorId,
  //         "200_bed": twoHundredFloorId,
  //         product_l: selectedProducts.length > 0 ? selectedProducts : "ALL",
  //         market_authorization_l:
  //           selectedMarketAuth.length > 0 ? selectedMarketAuth : "ALL",
  //         form_l: selectedForm.length > 0 ? selectedForm : "ALL",
  //         formulation_l:
  //           selectedFormulation.length > 0 ? selectedFormulation : "ALL",
  //         pack_l: selectedPackaging.length > 0 ? selectedPackaging : "ALL",
  //         product_type: productType.length > 0 ? productType : "ALL",
  //         prefecture:
  //           selectedPrefecture.length > 0 ? selectedPrefecture : "ALL",
  //         county: selectedCounty.length > 0 ? selectedCounty : "ALL",
  //         hemp_law_target_classification:
  //           selectedHempLaw.length > 0 ? selectedHempLaw : "ALL",
  //         company_copromotion_flg: salesCompany,
  //         drug_price: numericalItem === "salesAmount" ? 1 : 0,
  //         number_of_boxes: numericalItem === "packageQuantity" ? 1 : 0,
  //         received_and_paid_quantity: numericalItem === "bulkQuantity" ? 1 : 0,
  //         partition_amount:
  //           numericalItem === "salesAmountByWholesalerPurchasePrice" ? 1 : 0,
  //         actual_delivery_amount:
  //           numericalItem === "salesAmountByCustomerPurchasePrice" ? 1 : 0,
  //         sort_items: sortItem,
  //         fixed_month_japan_calendar: 1,
  //         fromDate: jpFromDate,
  //         toDate: jpToDate,
  //         userType: "CA",
  //         limit: limit,
  //         sort_field: sortField,
  //         sort_order: sortOrder,
  //       };
  //       setLazyLoading(false);
  //       if (reportListing.length <= total) {
  //         await getSelloutRotationCAReportList(body).then((response) => {
  //           if (
  //             response &&
  //             response.data &&
  //             response.data.data &&
  //             response.data.data.length > 0
  //           ) {
  //             let list = [];
  //             list = reportListing.concat(response.data.data);
  //             setReportListing(list);
  //           } else {
  //             setReportListing(reportListing);
  //           }
  //         });
  //         setLimit(limit + 10);
  //       }
  //     } else if (duration === "fixedMonthWholesale") {
  //       let body = {
  //         employee_wwid:
  //           details && details.length > 0 ? employeeList : [personInCharge],
  //         employee_all_select: allSelected,
  //         wholesaler_group:
  //           selectedWholesalerGroupList.length > 0
  //             ? selectedWholesalerGroupList
  //             : "ALL",
  //         wholesaler_Company_Code:
  //           selectedWholesalerCorporationList.length > 0
  //             ? selectedWholesalerCorporationList
  //             : "ALL",
  //         wholesale_management_sales_department:
  //           selectedWholesalerManagementList.length > 0
  //             ? selectedWholesalerManagementList
  //             : "ALL",
  //         wholesale_sales_department:
  //           selectedWholesalerSalesList.length > 0
  //             ? selectedWholesalerSalesList
  //             : "ALL",
  //         wholesale_branch:
  //           selectedWholesalerBranchList.length > 0
  //             ? selectedWholesalerBranchList
  //             : "ALL",
  //         wholesale_branch_section:
  //           selectedWholesalerBranchSectionList.length > 0
  //             ? selectedWholesalerBranchSectionList
  //             : "ALL",
  //         "100_bed": hundredFloorId,
  //         "200_bed": twoHundredFloorId,
  //         product_l: selectedProducts.length > 0 ? selectedProducts : "ALL",
  //         market_authorization_l:
  //           selectedMarketAuth.length > 0 ? selectedMarketAuth : "ALL",
  //         form_l: selectedForm.length > 0 ? selectedForm : "ALL",
  //         formulation_l:
  //           selectedFormulation.length > 0 ? selectedFormulation : "ALL",
  //         pack_l: selectedPackaging.length > 0 ? selectedPackaging : "ALL",
  //         product_type: productType.length > 0 ? productType : "ALL",
  //         prefecture:
  //           selectedPrefecture.length > 0 ? selectedPrefecture : "ALL",
  //         county: selectedCounty.length > 0 ? selectedCounty : "ALL",
  //         hemp_law_target_classification:
  //           selectedHempLaw.length > 0 ? selectedHempLaw : "ALL",
  //         company_copromotion_flg: salesCompany,
  //         drug_price: numericalItem === "salesAmount" ? 1 : 0,
  //         number_of_boxes: numericalItem === "packageQuantity" ? 1 : 0,
  //         received_and_paid_quantity: numericalItem === "bulkQuantity" ? 1 : 0,
  //         partition_amount:
  //           numericalItem === "salesAmountByWholesalerPurchasePrice" ? 1 : 0,
  //         actual_delivery_amount:
  //           numericalItem === "salesAmountByCustomerPurchasePrice" ? 1 : 0,
  //         sort_items: sortItem,
  //         fixed_month_wholesaler_calendar: 1,
  //         fromDate: wholesaleFromDate,
  //         toDate: wholesaleToDate,
  //         userType: "CA",
  //         limit: limit,
  //         sort_field: sortField,
  //         sort_order: sortOrder,
  //       };
  //       setLazyLoading(false);
  //       if (reportListing.length <= total) {
  //         await getSelloutRotationCAReportList(body).then((response) => {
  //           if (
  //             response &&
  //             response.data &&
  //             response.data.data &&
  //             response.data.data.length > 0
  //           ) {
  //             let list = [];
  //             list = reportListing.concat(response.data.data);
  //             setReportListing(list);
  //           } else {
  //             setReportListing(reportListing);
  //           }
  //         });
  //         setLimit(limit + 10);
  //       }
  //     } else if (duration === "targetPeriod") {
  //       let body = {
  //         employee_wwid:
  //           details && details.length > 0 ? employeeList : [personInCharge],
  //         employee_all_select: allSelected,
  //         wholesaler_group:
  //           selectedWholesalerGroupList.length > 0
  //             ? selectedWholesalerGroupList
  //             : "ALL",
  //         wholesaler_Company_Code:
  //           selectedWholesalerCorporationList.length > 0
  //             ? selectedWholesalerCorporationList
  //             : "ALL",
  //         wholesale_management_sales_department:
  //           selectedWholesalerManagementList.length > 0
  //             ? selectedWholesalerManagementList
  //             : "ALL",
  //         wholesale_sales_department:
  //           selectedWholesalerSalesList.length > 0
  //             ? selectedWholesalerSalesList
  //             : "ALL",
  //         wholesale_branch:
  //           selectedWholesalerBranchList.length > 0
  //             ? selectedWholesalerBranchList
  //             : "ALL",
  //         wholesale_branch_section:
  //           selectedWholesalerBranchSectionList.length > 0
  //             ? selectedWholesalerBranchSectionList
  //             : "ALL",
  //         "100_bed": hundredFloorId,
  //         "200_bed": twoHundredFloorId,
  //         product_l: selectedProducts.length > 0 ? selectedProducts : "ALL",
  //         market_authorization_l:
  //           selectedMarketAuth.length > 0 ? selectedMarketAuth : "ALL",
  //         form_l: selectedForm.length > 0 ? selectedForm : "ALL",
  //         formulation_l:
  //           selectedFormulation.length > 0 ? selectedFormulation : "ALL",
  //         pack_l: selectedPackaging.length > 0 ? selectedPackaging : "ALL",
  //         product_type: productType.length > 0 ? productType : "ALL",
  //         prefecture:
  //           selectedPrefecture.length > 0 ? selectedPrefecture : "ALL",
  //         county: selectedCounty.length > 0 ? selectedCounty : "ALL",
  //         hemp_law_target_classification:
  //           selectedHempLaw.length > 0 ? selectedHempLaw : "ALL",
  //         company_copromotion_flg: salesCompany,
  //         drug_price: numericalItem === "salesAmount" ? 1 : 0,
  //         number_of_boxes: numericalItem === "packageQuantity" ? 1 : 0,
  //         received_and_paid_quantity: numericalItem === "bulkQuantity" ? 1 : 0,
  //         partition_amount:
  //           numericalItem === "salesAmountByWholesalerPurchasePrice" ? 1 : 0,
  //         actual_delivery_amount:
  //           numericalItem === "salesAmountByCustomerPurchasePrice" ? 1 : 0,
  //         sort_items: sortItem,
  //         target_period: 1,
  //         fromDate: fromDate,
  //         toDate: toDate,
  //         userType: "CA",
  //         limit: limit,
  //         sort_field: sortField,
  //         sort_order: sortOrder,
  //       };
  //       setLazyLoading(false);
  //       if (reportListing.length <= total) {
  //         await getSelloutRotationCAReportList(body).then((response) => {
  //           if (
  //             response &&
  //             response.data &&
  //             response.data.data &&
  //             response.data.data.length > 0
  //           ) {
  //             let list = [];
  //             list = reportListing.concat(response.data.data);
  //             setReportListing(list);
  //           } else {
  //             setReportListing(reportListing);
  //           }
  //         });
  //         setLimit(limit + 10);
  //       }
  //     }
  //   }
  // };

  const loadRecords = async () => {
    if (reportListing.length > 0) {
      let employeeList = [];
      details.map((emp) => employeeList.push(emp.wwid));
      if (duration === "fixedMonthJP") {
        let body = {
          employee_wwid:
            details && details.length > 0 ? employeeList : [personInCharge],
          employee_all_select: allSelected,
          wholesaler_group:
            selectedWholesalerGroupList.length > 0
              ? selectedWholesalerGroupList
              : "ALL",
          wholesaler_Company_Code:
            selectedWholesalerCorporationList.length > 0
              ? selectedWholesalerCorporationList
              : "ALL",
          wholesale_management_sales_department:
            selectedWholesalerManagementList.length > 0
              ? selectedWholesalerManagementList
              : "ALL",
          wholesale_sales_department:
            selectedWholesalerSalesList.length > 0
              ? selectedWholesalerSalesList
              : "ALL",
          wholesale_branch:
            selectedWholesalerBranchList.length > 0
              ? selectedWholesalerBranchList
              : "ALL",
          wholesale_branch_section:
            selectedWholesalerBranchSectionList.length > 0
              ? selectedWholesalerBranchSectionList
              : "ALL",
          "100_bed": hundredFloorId,
          "200_bed": twoHundredFloorId,
          product_l: selectedProducts.length > 0 ? selectedProducts : "ALL",
          market_authorization_l:
            selectedMarketAuth.length > 0 ? selectedMarketAuth : "ALL",
          form_l: selectedForm.length > 0 ? selectedForm : "ALL",
          formulation_l:
            selectedFormulation.length > 0 ? selectedFormulation : "ALL",
          pack_l: selectedPackaging.length > 0 ? selectedPackaging : "ALL",
          product_type: productType.length > 0 ? productType : "ALL",
          prefecture:
            selectedPrefecture.length > 0 ? selectedPrefecture : "ALL",
          county: selectedCounty.length > 0 ? selectedCounty : "ALL",
          hemp_law_target_classification:
            selectedHempLaw.length > 0 ? selectedHempLaw : "ALL",
          company_copromotion_flg: salesCompany,
          drug_price: numericalItem === "salesAmount" ? 1 : 0,
          number_of_boxes: numericalItem === "packageQuantity" ? 1 : 0,
          received_and_paid_quantity: numericalItem === "bulkQuantity" ? 1 : 0,
          partition_amount:
            numericalItem === "salesAmountByWholesalerPurchasePrice" ? 1 : 0,
          actual_delivery_amount:
            numericalItem === "salesAmountByCustomerPurchasePrice" ? 1 : 0,
          sort_items: sortItem,
          fixed_month_japan_calendar: 1,
          fromDate: jpFromDate,
          toDate: jpToDate,
          userType: "CA",
          limit: limit,
          sort_field: sortField,
          sort_order: sortOrder,
        };
        if (reportListing.length < total) {
          setLazyLoading(true);
          await getSelloutRotationCAReportList(body).then((response) => {
            if (
              response &&
              response.data &&
              response.data.data &&
              response.data.data.length > 0
            ) {
              let list = [];
              list = reportListing.concat(response.data.data);
              setLazyLoading(false);
              setReportListing(list);
            } else {
              setLazyLoading(false);
              setReportListing(reportListing);
            }
          });
          setLimit(limit + LOAD_MORE_PAGE_SIZE);
        }
      } else if (duration === "fixedMonthWholesale") {
        let body = {
          employee_wwid:
            details && details.length > 0 ? employeeList : [personInCharge],
          employee_all_select: allSelected,
          wholesaler_group:
            selectedWholesalerGroupList.length > 0
              ? selectedWholesalerGroupList
              : "ALL",
          wholesaler_Company_Code:
            selectedWholesalerCorporationList.length > 0
              ? selectedWholesalerCorporationList
              : "ALL",
          wholesale_management_sales_department:
            selectedWholesalerManagementList.length > 0
              ? selectedWholesalerManagementList
              : "ALL",
          wholesale_sales_department:
            selectedWholesalerSalesList.length > 0
              ? selectedWholesalerSalesList
              : "ALL",
          wholesale_branch:
            selectedWholesalerBranchList.length > 0
              ? selectedWholesalerBranchList
              : "ALL",
          wholesale_branch_section:
            selectedWholesalerBranchSectionList.length > 0
              ? selectedWholesalerBranchSectionList
              : "ALL",
          "100_bed": hundredFloorId,
          "200_bed": twoHundredFloorId,
          product_l: selectedProducts.length > 0 ? selectedProducts : "ALL",
          market_authorization_l:
            selectedMarketAuth.length > 0 ? selectedMarketAuth : "ALL",
          form_l: selectedForm.length > 0 ? selectedForm : "ALL",
          formulation_l:
            selectedFormulation.length > 0 ? selectedFormulation : "ALL",
          pack_l: selectedPackaging.length > 0 ? selectedPackaging : "ALL",
          product_type: productType.length > 0 ? productType : "ALL",
          prefecture:
            selectedPrefecture.length > 0 ? selectedPrefecture : "ALL",
          county: selectedCounty.length > 0 ? selectedCounty : "ALL",
          hemp_law_target_classification:
            selectedHempLaw.length > 0 ? selectedHempLaw : "ALL",
          company_copromotion_flg: salesCompany,
          drug_price: numericalItem === "salesAmount" ? 1 : 0,
          number_of_boxes: numericalItem === "packageQuantity" ? 1 : 0,
          received_and_paid_quantity: numericalItem === "bulkQuantity" ? 1 : 0,
          partition_amount:
            numericalItem === "salesAmountByWholesalerPurchasePrice" ? 1 : 0,
          actual_delivery_amount:
            numericalItem === "salesAmountByCustomerPurchasePrice" ? 1 : 0,
          sort_items: sortItem,
          fixed_month_wholesaler_calendar: 1,
          fromDate: wholesaleFromDate,
          toDate: wholesaleToDate,
          userType: "CA",
          limit: limit,
          sort_field: sortField,
          sort_order: sortOrder,
        };
        if (reportListing.length < total) {
          setLazyLoading(true);
          await getSelloutRotationCAReportList(body).then((response) => {
            if (
              response &&
              response.data &&
              response.data.data &&
              response.data.data.length > 0
            ) {
              let list = [];
              list = reportListing.concat(response.data.data);
              setLazyLoading(false);
              setReportListing(list);
            } else {
              setLazyLoading(false);
              setReportListing(reportListing);
            }
          });
          setLimit(limit + LOAD_MORE_PAGE_SIZE);
        }
      } else if (duration === "targetPeriod") {
        let body = {
          employee_wwid:
            details && details.length > 0 ? employeeList : [personInCharge],
          employee_all_select: allSelected,
          wholesaler_group:
            selectedWholesalerGroupList.length > 0
              ? selectedWholesalerGroupList
              : "ALL",
          wholesaler_Company_Code:
            selectedWholesalerCorporationList.length > 0
              ? selectedWholesalerCorporationList
              : "ALL",
          wholesale_management_sales_department:
            selectedWholesalerManagementList.length > 0
              ? selectedWholesalerManagementList
              : "ALL",
          wholesale_sales_department:
            selectedWholesalerSalesList.length > 0
              ? selectedWholesalerSalesList
              : "ALL",
          wholesale_branch:
            selectedWholesalerBranchList.length > 0
              ? selectedWholesalerBranchList
              : "ALL",
          wholesale_branch_section:
            selectedWholesalerBranchSectionList.length > 0
              ? selectedWholesalerBranchSectionList
              : "ALL",
          "100_bed": hundredFloorId,
          "200_bed": twoHundredFloorId,
          product_l: selectedProducts.length > 0 ? selectedProducts : "ALL",
          market_authorization_l:
            selectedMarketAuth.length > 0 ? selectedMarketAuth : "ALL",
          form_l: selectedForm.length > 0 ? selectedForm : "ALL",
          formulation_l:
            selectedFormulation.length > 0 ? selectedFormulation : "ALL",
          pack_l: selectedPackaging.length > 0 ? selectedPackaging : "ALL",
          product_type: productType.length > 0 ? productType : "ALL",
          prefecture:
            selectedPrefecture.length > 0 ? selectedPrefecture : "ALL",
          county: selectedCounty.length > 0 ? selectedCounty : "ALL",
          hemp_law_target_classification:
            selectedHempLaw.length > 0 ? selectedHempLaw : "ALL",
          company_copromotion_flg: salesCompany,
          drug_price: numericalItem === "salesAmount" ? 1 : 0,
          number_of_boxes: numericalItem === "packageQuantity" ? 1 : 0,
          received_and_paid_quantity: numericalItem === "bulkQuantity" ? 1 : 0,
          partition_amount:
            numericalItem === "salesAmountByWholesalerPurchasePrice" ? 1 : 0,
          actual_delivery_amount:
            numericalItem === "salesAmountByCustomerPurchasePrice" ? 1 : 0,
          sort_items: sortItem,
          target_period: 1,
          fromDate: fromDate,
          toDate: toDate,
          userType: "CA",
          limit: limit,
          sort_field: sortField,
          sort_order: sortOrder,
        };
        if (reportListing.length < total) {
          setLazyLoading(true);
          await getSelloutRotationCAReportList(body).then((response) => {
            if (
              response &&
              response.data &&
              response.data.data &&
              response.data.data.length > 0
            ) {
              let list = [];
              list = reportListing.concat(response.data.data);
              setLazyLoading(false);
              setReportListing(list);
            } else {
              setLazyLoading(false);
              setReportListing(reportListing);
            }
          });
          setLimit(limit + LOAD_MORE_PAGE_SIZE);
        }
      }
    }
  };

  const handleSortingData = async (obj) => {
    setSortField(obj.column);
    setSortOrder(obj.sortOrder);
    obj.column === "wholesale_corporation_name" &&
      setSortCorporationName(obj.sortOrder);
    obj.column === "delivered_facility_name" &&
      setSortDeliveryFacility(obj.sortOrder);
    obj.column === "product_l" && setSortProduct(obj.sortOrder);
    obj.column === "market_authorization_l" && setSortMarket(obj.sortOrder);
    obj.column === "form_l" && setSortForm(obj.sortOrder);
    obj.column === "formulation_l" && setSortFormulation(obj.sortOrder);
    obj.column === "pack_l" && setSortPack(obj.sortOrder);
    let employeeList = [];
    details.map((emp) => employeeList.push(emp.wwid));
    if (duration === "fixedMonthJP") {
      let body = {
        employee_wwid:
          details && details.length > 0 ? employeeList : [personInCharge],
        employee_all_select: allSelected,
        wholesaler_group:
          selectedWholesalerGroupList.length > 0
            ? selectedWholesalerGroupList
            : "ALL",
        wholesaler_Company_Code:
          selectedWholesalerCorporationList.length > 0
            ? selectedWholesalerCorporationList
            : "ALL",
        wholesale_management_sales_department:
          selectedWholesalerManagementList.length > 0
            ? selectedWholesalerManagementList
            : "ALL",
        wholesale_sales_department:
          selectedWholesalerSalesList.length > 0
            ? selectedWholesalerSalesList
            : "ALL",
        wholesale_branch:
          selectedWholesalerBranchList.length > 0
            ? selectedWholesalerBranchList
            : "ALL",
        wholesale_branch_section:
          selectedWholesalerBranchSectionList.length > 0
            ? selectedWholesalerBranchSectionList
            : "ALL",
        "100_bed": hundredFloorId,
        "200_bed": twoHundredFloorId,
        product_l: selectedProducts.length > 0 ? selectedProducts : "ALL",
        market_authorization_l:
          selectedMarketAuth.length > 0 ? selectedMarketAuth : "ALL",
        form_l: selectedForm.length > 0 ? selectedForm : "ALL",
        formulation_l:
          selectedFormulation.length > 0 ? selectedFormulation : "ALL",
        pack_l: selectedPackaging.length > 0 ? selectedPackaging : "ALL",
        product_type: productType.length > 0 ? productType : "ALL",
        prefecture: selectedPrefecture.length > 0 ? selectedPrefecture : "ALL",
        county: selectedCounty.length > 0 ? selectedCounty : "ALL",
        hemp_law_target_classification:
          selectedHempLaw.length > 0 ? selectedHempLaw : "ALL",
        company_copromotion_flg: salesCompany,
        drug_price: numericalItem === "salesAmount" ? 1 : 0,
        number_of_boxes: numericalItem === "packageQuantity" ? 1 : 0,
        received_and_paid_quantity: numericalItem === "bulkQuantity" ? 1 : 0,
        partition_amount:
          numericalItem === "salesAmountByWholesalerPurchasePrice" ? 1 : 0,
        actual_delivery_amount:
          numericalItem === "salesAmountByCustomerPurchasePrice" ? 1 : 0,
        sort_items: sortItem,
        fixed_month_japan_calendar: 1,
        fromDate: jpFromDate,
        toDate: jpToDate,
        userType: "CA",
        sort_field: obj.column,
        sort_order: obj.sortOrder,
      };
      setLazyLoading(false);
      await getSelloutRotationCAReportList(body).then((response) => {
        if (response.success === true && response.data.data.length > 0) {
          setReportListing(response && response.data && response.data.data);
          setHeaders(response.data.header);
          let count = response.data.total_count.split(",");
          setTotal(parseInt(count.join("")));
          setShowUserMessage(false);
          setNoData(false);
          setLoading(false);
        } else if (
          (response.success === true && response.data.data.length === 0) ||
          response.success === false
        ) {
          setNoData(true);
          setLoading(false);
          setReportListing([]);
          setTotal();
        }
      });
    } else if (duration === "fixedMonthWholesale") {
      let body = {
        employee_wwid:
          details && details.length > 0 ? employeeList : [personInCharge],
        employee_all_select: allSelected,
        wholesaler_group:
          selectedWholesalerGroupList.length > 0
            ? selectedWholesalerGroupList
            : "ALL",
        wholesaler_Company_Code:
          selectedWholesalerCorporationList.length > 0
            ? selectedWholesalerCorporationList
            : "ALL",
        wholesale_management_sales_department:
          selectedWholesalerManagementList.length > 0
            ? selectedWholesalerManagementList
            : "ALL",
        wholesale_sales_department:
          selectedWholesalerSalesList.length > 0
            ? selectedWholesalerSalesList
            : "ALL",
        wholesale_branch:
          selectedWholesalerBranchList.length > 0
            ? selectedWholesalerBranchList
            : "ALL",
        wholesale_branch_section:
          selectedWholesalerBranchSectionList.length > 0
            ? selectedWholesalerBranchSectionList
            : "ALL",
        "100_bed": hundredFloorId,
        "200_bed": twoHundredFloorId,
        product_l: selectedProducts.length > 0 ? selectedProducts : "ALL",
        market_authorization_l:
          selectedMarketAuth.length > 0 ? selectedMarketAuth : "ALL",
        form_l: selectedForm.length > 0 ? selectedForm : "ALL",
        formulation_l:
          selectedFormulation.length > 0 ? selectedFormulation : "ALL",
        pack_l: selectedPackaging.length > 0 ? selectedPackaging : "ALL",
        product_type: productType.length > 0 ? productType : "ALL",
        prefecture: selectedPrefecture.length > 0 ? selectedPrefecture : "ALL",
        county: selectedCounty.length > 0 ? selectedCounty : "ALL",
        hemp_law_target_classification:
          selectedHempLaw.length > 0 ? selectedHempLaw : "ALL",
        company_copromotion_flg: salesCompany,
        drug_price: numericalItem === "salesAmount" ? 1 : 0,
        number_of_boxes: numericalItem === "packageQuantity" ? 1 : 0,
        received_and_paid_quantity: numericalItem === "bulkQuantity" ? 1 : 0,
        partition_amount:
          numericalItem === "salesAmountByWholesalerPurchasePrice" ? 1 : 0,
        actual_delivery_amount:
          numericalItem === "salesAmountByCustomerPurchasePrice" ? 1 : 0,
        sort_items: sortItem,
        fixed_month_wholesaler_calendar: 1,
        fromDate: wholesaleFromDate,
        toDate: wholesaleToDate,
        userType: "CA",
        sort_field: obj.column,
        sort_order: obj.sortOrder,
      };
      setLazyLoading(false);
      await getSelloutRotationCAReportList(body).then((response) => {
        if (response.success === true && response.data.data.length > 0) {
          setReportListing(response && response.data && response.data.data);
          setHeaders(response.data.header);
          let count = response.data.total_count.split(",");
          setTotal(parseInt(count.join("")));
          setShowUserMessage(false);
          setNoData(false);
          setLoading(false);
        } else if (
          (response.success === true && response.data.data.length === 0) ||
          response.success === false
        ) {
          setNoData(true);
          setLoading(false);
          setReportListing([]);
          setTotal();
        }
      });
    } else if (duration === "targetPeriod") {
      let body = {
        employee_wwid:
          details && details.length > 0 ? employeeList : [personInCharge],
        employee_all_select: allSelected,
        wholesaler_group:
          selectedWholesalerGroupList.length > 0
            ? selectedWholesalerGroupList
            : "ALL",
        wholesaler_Company_Code:
          selectedWholesalerCorporationList.length > 0
            ? selectedWholesalerCorporationList
            : "ALL",
        wholesale_management_sales_department:
          selectedWholesalerManagementList.length > 0
            ? selectedWholesalerManagementList
            : "ALL",
        wholesale_sales_department:
          selectedWholesalerSalesList.length > 0
            ? selectedWholesalerSalesList
            : "ALL",
        wholesale_branch:
          selectedWholesalerBranchList.length > 0
            ? selectedWholesalerBranchList
            : "ALL",
        wholesale_branch_section:
          selectedWholesalerBranchSectionList.length > 0
            ? selectedWholesalerBranchSectionList
            : "ALL",
        "100_bed": hundredFloorId,
        "200_bed": twoHundredFloorId,
        product_l: selectedProducts.length > 0 ? selectedProducts : "ALL",
        market_authorization_l:
          selectedMarketAuth.length > 0 ? selectedMarketAuth : "ALL",
        form_l: selectedForm.length > 0 ? selectedForm : "ALL",
        formulation_l:
          selectedFormulation.length > 0 ? selectedFormulation : "ALL",
        pack_l: selectedPackaging.length > 0 ? selectedPackaging : "ALL",
        product_type: productType.length > 0 ? productType : "ALL",
        prefecture: selectedPrefecture.length > 0 ? selectedPrefecture : "ALL",
        county: selectedCounty.length > 0 ? selectedCounty : "ALL",
        hemp_law_target_classification:
          selectedHempLaw.length > 0 ? selectedHempLaw : "ALL",
        company_copromotion_flg: salesCompany,
        drug_price: numericalItem === "salesAmount" ? 1 : 0,
        number_of_boxes: numericalItem === "packageQuantity" ? 1 : 0,
        received_and_paid_quantity: numericalItem === "bulkQuantity" ? 1 : 0,
        partition_amount:
          numericalItem === "salesAmountByWholesalerPurchasePrice" ? 1 : 0,
        actual_delivery_amount:
          numericalItem === "salesAmountByCustomerPurchasePrice" ? 1 : 0,
        sort_items: sortItem,
        target_period: 1,
        fromDate: fromDate,
        toDate: toDate,
        userType: "CA",
        sort_field: obj.column,
        sort_order: obj.sortOrder,
      };
      setLazyLoading(false);
      await getSelloutRotationCAReportList(body).then((response) => {
        if (response.success === true && response.data.data.length > 0) {
          setReportListing(response && response.data && response.data.data);
          setHeaders(response.data.header);
          let count = response.data.total_count.split(",");
          setTotal(parseInt(count.join("")));
          setShowUserMessage(false);
          setNoData(false);
          setLoading(false);
        } else if (
          (response.success === true && response.data.data.length === 0) ||
          response.success === false
        ) {
          setNoData(true);
          setLoading(false);
          setReportListing([]);
          setTotal();
        }
      });
    }
  };

  const compareBySortedData = (obj) => {
    const sorted = reportListing.sort((a, b) => {
      const isReversed = obj.sortOrder === "asc" ? 1 : -1;
      let first = a[obj.column] ? a[obj.column] : "";
      let second = b[obj.column] ? b[obj.column] : "";
      return isReversed * first.localeCompare(second);
    });
    return sorted;
  };
  const filterOption = (input, option) => {
    return option.label.toLowerCase().indexOf(input.toLowerCase()) !== -1;
  };
  // const containerRef = useBottomScrollListener(handleContainerOnBottom);

  const [text, setText] = useState({})
  const [language, setLang] = useState({})

  useEffect(() => {
    if(sessionStorage.getItem("translation")){
      setText(JSON.parse(sessionStorage.getItem("translation")))
    }
    if(sessionStorage.getItem("translation")){
      setLang(sessionStorage.getItem("Language"))
    }
  }, [sessionStorage.getItem("Language")]);

  const [finalText, setfinalText] = useState('')
  const [finalText2, setfinalText2] = useState("");
  useEffect(() => {
    const searchText = "salesreport";
    const filteredTexts2 = {};
    const searchText2 = "commonmessage";
    const filteredTexts = {};
    for (const key in text) {
      if (key.includes(searchText)) {
        if (key.endsWith('_en') || key.endsWith('_ja')) {
          const langKey = key.includes("_en") ? "en" : "jp";
          const value = text[key];
          filteredTexts[langKey] = value;
        }
      }
    }
    for (const key in text) {
      if (key.includes(searchText2)) {
        if (key.endsWith('_en') || key.endsWith('_ja')) {
          const langKey = key.includes("_en") ? "en" : "jp";
          const value = text[key];
          filteredTexts2[langKey] = value;
        }
      }
    }
    if(filteredTexts[language]){
      setfinalText(filteredTexts[language])
    }
    if (filteredTexts2[language]) {
      setfinalText2(filteredTexts2[language]);
    }

  }, [language,text]);

  return role ? (
    <Home>
      <Breadcrumb finalText2={finalText2} finalText={finalText} routes={routes} />
      {isScreenLoading && <Spinner animation="border" />}
      {maintenance === "1" && (
        <>
          <Accordion defaultActiveKey="0">
            <Accordion.Item eventKey="0">
              <Accordion.Header>{lang("SalesMenu.selloutRotationByWholesaler")}</Accordion.Header>
              <Accordion.Body>
                  <div className="user-details">
                    <div className="row">
                      <div className="col-md-4">
                        {lang("dailySellout.processingDate")}: {processingDate}
                      </div>
                      {/* <div className="col-md-4">
                    {lang("dailySellout.loginName")}: {loginName}
                  </div>
                  <div className="col-md-4">
                    {lang("dailySellout.organizationName")}: {organizationName}
                  </div> */}
                    </div>
                  </div>
                  <div className="horizon-form">
                    <div className="custom-3">
                      <label>{lang("dailySellout.personInCharge")}</label>
                    </div>
                    <div className="custom-9">
                      <div className="row">
                        <div className="col-md-4">
                          <div className="form-group">
                            <input
                              type="text"
                              className="form-control"
                              value={personName}
                              disabled
                            />
                          </div>
                        </div>
                        <div className="col-md-4">
                          <div className="form-group">
                            <button
                              className="btn btn-primary"
                              onClick={(e) => changeRoute(e, "/searchMembers")}
                            >
                              {lang("dailySellout.selectPersonInCharge")}
                            </button>
                            <div className="custom-checkbox d-inline-block mr-3 ml-3 mb-2">
                              <input
                                type="checkbox"
                                id="status3"
                                name="status"
                                value={allSelected}
                                onChange={(e) => handleAllSelected(e)}
                              />
                              <label htmlFor="status3">
                                {lang("dailySellout.allSelection")}
                              </label>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-4">
                          <p className="annotations">
                            ★ {lang("annotations.personInChargeAnnotation")}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="horizon-form">
                    <div className="custom-3">
                      <label>{lang("dailySellout.targetPeriod")}</label>
                    </div>
                    <div className="custom-9">
                      <div className="row">
                        <div className="col-md-2 mt-3 mb-4">
                          <div className="custom-radio d-inline-block">
                            <input
                              type="radio"
                              id="fixedMonthJP"
                              name="duration"
                              value="fixedMonthJP"
                              onChange={(e) => handleDuration(e)}
                              defaultChecked
                            />
                            <label htmlFor="fixedMonthJP">
                              {lang("dailySellout.fixedMonthJPYear")}
                            </label>
                          </div>
                        </div>
                        <div className="col-md-6 mt-3 mb-4">
                          <p>
                            {jpFromDateDisplay} - {jpToDateDisplay}
                          </p>
                        </div>
                        <div className="col-md-4 mt-3 mb-4">
                          <p className="annotations">
                            ★ {lang("annotations.jpDuration")}
                          </p>
                        </div>
                        <div className="col-md-2 mt-3 mb-4">
                          <div className="custom-radio d-inline-block">
                            <input
                              type="radio"
                              id="fixedMonthWholesale"
                              name="duration"
                              value="fixedMonthWholesale"
                              onChange={(e) => handleDuration(e)}
                            />
                            <label htmlFor="fixedMonthWholesale">
                              {lang("dailySellout.fixedMonthWholesaleYear")}
                            </label>
                          </div>
                        </div>
                        <div className="col-md-6 mt-3 mb-4">
                          <p>
                            {wholesaleFromDateDisplay} -{" "}
                            {wholesaleToDateDisplay}
                          </p>
                        </div>
                        <div className="col-md-4 mt-3 mb-4">
                          <p className="annotations">
                            ★ {lang("annotations.wholesaleDuration")}
                          </p>
                        </div>
                        <div className="col-md-12 mt-3 mb-4">
                          <div className="row">
                            <div className="col-md-2">
                              <div className="custom-radio d-inline-block">
                                <input
                                  type="radio"
                                  id="targetPeriod"
                                  name="duration"
                                  value="targetPeriod"
                                  onChange={(e) => handleDuration(e)}
                                />
                                <label htmlFor="targetPeriod">
                                  {lang("dailySellout.targetPeriod")}
                                </label>
                              </div>
                            </div>
                            <div className="col-md-6">
                              {duration === "targetPeriod" && (
                                <div className="row">
                                  <div className="col-lg-4 col-md-6">
                                    <div className="form-group">
                                      {/* <label>{lang("PersonMenu.from")}</label> */}
                                      <DatePicker
                                        value={fromDateDisplay}      
                                        minDate={startDate}
                                        maxDate={endDate}
                                        peekNextMonth
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                        className="form-control"
                                        onChange={(date) =>
                                          handleFromYear(date)
                                        }
                                      />
                                    </div>
                                  </div>
                                  <p style={{ margin: "10px 0" }}>~</p>
                                  <div className="col-lg-4 col-md-6">
                                    <div className="form-group">
                                      {/* <label>{lang("PersonMenu.to")}</label> */}
                                      <DatePicker
                                        value={toDateDisplay}     
                                        minDate={startDate}
                                        maxDate={endDate}
                                        peekNextMonth
                                        showMonthDropdown
                                        showYearDropdown
                                        dropdownMode="select"
                                        className="form-control"
                                        onChange={(date) => handleToYear(date)}
                                      />
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                            <div className="col-md-4 mt-3 mb-4">
                              <p className="annotations">
                                ★ {lang("annotations.target")}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="horizon-form">
                    <div className="custom-3">
                      <label>
                        {lang("dailySellout.wholesalerOrganization")}
                      </label>
                    </div>
                    <div className="custom-9">
                      <div className="row">
                        <div className="col-xl-3 col-md-4">
                          <div className="form-group">
                            <label>
                              {lang("dailySellout.wholesalerGroup")}
                            </label>
                            <Select
                              // className="ant-select"
                              mode="multiple"
                              value={selectedWholesalerGroupList}
                              placeholder={
                                lang("dailySellout.wholesalerGroup") +
                                " (" +
                                lang("dailySellout.all") +
                                ")"
                              }
                              options={wholesalerGroupList}
                              showSearch={
                                wholesalerGroupList &&
                                wholesalerGroupList.length > 0
                              }
                              onChange={handleWholesalerGroupChange}
                              onSelect={(e, value) =>
                                handleWholeSalerGroupSelect(e, value)
                              }
                            />
                          </div>
                        </div>
                        <div className="col-xl-3 col-md-4">
                          <div className="form-group">
                            <label>
                              {lang("dailySellout.wholesaleCorporation")}
                            </label>
                            <Select
                              // className="ant-select"
                              mode="multiple"
                              placeholder={
                                lang("dailySellout.wholesaleCorporation") +
                                " (" +
                                lang("dailySellout.all") +
                                ")"
                              }
                              showSearch={
                                wholesalerCorporationList &&
                                wholesalerCorporationList.length > 0
                              }
                              options={wholesalerCorporationList}
                              value={selectedWholesalerCorporationList}
                              loading={wholesaleCorporationLoading}
                              // disabled={selectedWholesalerGroupList.length > 0 ? false : true}
                              onChange={handleWholesalerCorporationChange}
                              onSelect={(e, value) =>
                                handleWholeSalerCorporationSelect(e, value)
                              }
                            />
                          </div>
                        </div>
                        <div className="col-xl-3 col-md-4">
                          <div className="form-group">
                            <label>
                              {lang(
                                "dailySellout.wholesaleManagementSalesDepartment"
                              )}
                            </label>
                            <Select
                              // className="ant-select"
                              mode="multiple"
                              placeholder={
                                lang(
                                  "dailySellout.wholesaleManagementSalesDepartment"
                                ) +
                                " (" +
                                lang("dailySellout.all") +
                                ")"
                              }
                              value={selectedWholesalerManagementList}
                              loading={wholesaleManagementSalesLoading}
                              // disabled={selectedWholesalerCorporationList.length > 0 ? false : true}
                              options={wholesalerManagementList}
                              onChange={handleWholesalerManagementChange}
                              onSelect={(e, value) =>
                                handleWholeSalerManagementSelect(e, value)
                              }
                            />
                          </div>
                        </div>
                        <div className="col-xl-3 col-md-4">
                          <div className="form-group">
                            <label>
                              {lang("dailySellout.wholesaleSalesDepartment")}
                            </label>
                            <Select
                              // className="ant-select"
                              mode="multiple"
                              placeholder={
                                lang("dailySellout.wholesaleSalesDepartment") +
                                " (" +
                                lang("dailySellout.all") +
                                ")"
                              }
                              options={wholesalerSalesList}
                              value={selectedWholesalerSalesList}
                              loading={wholesaleSalesLoading}
                              // disabled={selectedWholesalerManagementList.length > 0 ? false : true}
                              onChange={handleWholesalerSalesChange}
                              onSelect={(e, value) =>
                                handleWholeSalerSalesSelect(e, value)
                              }
                            />
                          </div>
                        </div>
                        <div className="col-xl-3 col-md-4">
                          <div className="form-group">
                            <label>
                              {lang("dailySellout.wholesaleBranchName")}
                            </label>
                            <Select
                              // className="ant-select"
                              mode="multiple"
                              placeholder={
                                lang("dailySellout.wholesaleBranchName") +
                                " (" +
                                lang("dailySellout.all") +
                                ")"
                              }
                              options={wholesalerBranchList}
                              value={selectedWholesalerBranchList}
                              loading={wholesaleBranchLoading}
                              // disabled={selectedWholesalerSalesList.length > 0 ? false : true}
                              onChange={handleWholesalerBranchChange}
                              onSelect={(e, value) =>
                                handleWholeSalerBranchSelect(e, value)
                              }
                            />
                          </div>
                        </div>
                        <div className="col-xl-3 col-md-4">
                          <div className="form-group">
                            <label>
                              {lang("dailySellout.wholesaleBranchSection")}
                            </label>
                            <Select
                              // className="ant-select"
                              mode="multiple"
                              placeholder={
                                lang(
                                  "dailySellout.wholesaleManagementSalesDepartment"
                                ) +
                                " (" +
                                lang("dailySellout.all") +
                                ")"
                              }
                              options={wholesalerBranchSectionList}
                              value={selectedWholesalerBranchSectionList}
                              loading={wholesaleBranchSectionLoading}
                              // disabled={selectedWholesalerBranchList.length > 0 ? false : true}
                              onChange={handleWholesalerBranchSectionChange}
                              onSelect={(e, value) =>
                                handleWholeSalerBranchSectionSelect(e, value)
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="horizon-form">
                    <div className="custom-3">
                      <label>
                        {lang("dailySellout.areaWholesaleParentFacility")}
                      </label>
                    </div>
                    <div className="custom-9">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>
                              {lang(
                                "parentChildFacilityMaintenance.prefecture"
                              )}
                            </label>
                            <Select
                              className="ant-select"
                              mode="multiple"
                              filterOption={filterOption}
                              options={prefectureList}
                              placeholder={lang(
                                "parentChildFacilityMaintenance.prefecture"
                              )}
                              onChange={handlePrefectureChange}
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>{lang("dailySellout.cityAndCounty")}</label>
                            <Select
                              className="ant-select"
                              options={countyList}
                              filterOption={filterOption}
                              mode="multiple"
                              value={selectedCounty}
                              placeholder={lang("dailySellout.cityAndCounty")}
                              loading={cityLoading}
                              disabled={
                                selectedPrefecture.length > 0 ? false : true
                              }
                              onChange={handleCountyChange}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="horizon-form">
                    <div className="custom-3">
                      <label>
                        {lang("dailySellout.facilityClassification")}
                      </label>
                    </div>
                    <div className="custom-9">
                      <div className="row">
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>
                              {lang("dailySellout.hundredBedClassification")}
                            </label>
                            <Select
                              className="ant-select"
                              options={hundredBedsList}
                              defaultValue={hundredBedsList[0]}
                              placeholder={lang(
                                "dailySellout.hundredBedClassification"
                              )}
                              onChange={handleHundredFloorChange}
                              labelInValue={true}
                              showSearch
                              optionFilterProp="label"
                            />
                          </div>
                        </div>
                        <div className="col-md-6">
                          <div className="form-group">
                            <label>
                              {lang("dailySellout.twoHundredBedClassification")}
                            </label>
                            <Select
                              className="ant-select"
                              options={twoHundredBedsList}
                              defaultValue={twoHundredBedsList[0]}
                              placeholder={lang(
                                "dailySellout.twoHundredBedClassification"
                              )}
                              onChange={handleTwoHundredFloorChange}
                              labelInValue={true}
                              showSearch
                              optionFilterProp="label"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="horizon-form mt-3 mb-4">
                    <div className="custom-3">
                      <label>{lang("dailySellout.productType")}</label>
                    </div>
                    <div className="custom-9">
                      <div className="row">
                        <div className="col-md-6">
                          <label>{lang("dailySellout.productType")}</label>
                          <Select
                            className="ant-select"
                            mode="multiple"
                            options={productTypeList}
                            placeholder={lang("dailySellout.productType")}
                            onChange={handleProductTypeChange}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="horizon-form">
                    <div className="custom-3">
                      <label>{lang("dailySellout.productInformation")}</label>
                    </div>
                    <div className="custom-9">
                      <div className="row">
                        <div className="col-xl-3 col-md-4">
                          <div className="form-group">
                            <label>{lang("dailySellout.productL")}</label>
                            <Select
                              mode="multiple"
                              className="ant-select"
                              filterOption={filterOption}
                              options={productsList}
                              placeholder={
                                lang("dailySellout.productL") +
                                " (" +
                                lang("dailySellout.all") +
                                ")"
                              }
                              value={selectedProducts}
                              // disabled={details.length === 1}
                              showSearch={
                                productsList && productsList.length > 0
                              }
                              onChange={handleProductChange}
                              onSelect={(e, value) =>
                                handleProductSelect(e, value)
                              }
                            />
                          </div>
                        </div>
                        <div className="col-xl-3 col-md-4">
                          <div className="form-group">
                            <label>
                              {lang("dailySellout.marketAuthorizationL")}
                            </label>
                            <Select
                              className="ant-select"
                              mode="multiple"
                              // disabled={selectedProducts.length > 0 ? false : true}
                              filterOption={filterOption}
                              options={marketAuthList}
                              placeholder={
                                lang("dailySellout.marketAuthorizationL") +
                                " (" +
                                lang("dailySellout.all") +
                                ")"
                              }
                              value={selectedMarketAuth}
                              showSearch={
                                marketAuthList && marketAuthList.length > 0
                              }
                              loading={marketLoading}
                              onChange={handleMarketAuthorizationChange}
                              onSelect={(e, value) =>
                                handleMarketAuthSelect(e, value)
                              }
                            />
                          </div>
                        </div>
                        <div className="col-xl-3 col-md-4">
                          <div className="form-group">
                            <label>{lang("dailySellout.formL")}</label>
                            <Select
                              className="ant-select"
                              mode="multiple"
                              filterOption={filterOption}
                              options={formList}
                              placeholder={
                                lang("dailySellout.formL") +
                                " (" +
                                lang("dailySellout.all") +
                                ")"
                              }
                              value={selectedForm}
                              // disabled={selectedMarketAuth.length > 0 ? false : true}
                              showSearch={
                                formList && formList.length > 0
                              }
                              loading={formLoading}
                              onChange={handleFormChange}
                              onSelect={(e, value) =>
                                handleFormSelect(e, value)
                              }
                            />
                          </div>
                        </div>
                        <div className="col-xl-3 col-md-4">
                          <div className="form-group">
                            <label>{lang("dailySellout.formulationL")}</label>
                            <Select
                              className="ant-select"
                              mode="multiple"
                              filterOption={filterOption}
                              options={formulationList}
                              value={selectedFormulation}
                              placeholder={
                                lang("dailySellout.formulationL") +
                                " (" +
                                lang("dailySellout.all") +
                                ")"
                              }
                              // disabled={selectedForm.length > 0  ? false : true}
                              showSearch={
                                formulationList && formulationList.length > 0
                              }
                              loading={formulationLoading}
                              onChange={handleFormulationChange}
                              onSelect={(e, value) =>
                                handleFormulationSelect(e, value)
                              }
                            />
                          </div>
                        </div>
                        <div className="col-xl-3 col-md-4">
                          <div className="form-group">
                            <label>{lang("dailySellout.packL")}</label>
                            <Select
                              className="ant-select"
                              mode="multiple"
                              filterOption={filterOption}
                              options={packagingList}
                              placeholder={
                                lang("dailySellout.packL") +
                                " (" +
                                lang("dailySellout.all") +
                                ")"
                              }
                              value={selectedPackaging}
                              // disabled={selectedFormulation.length > 0 ? false : true}
                              showSearch={
                                packagingList && packagingList.length > 0
                              }
                              loading={packLoading}
                              onChange={handlePackagingChange}
                              onSelect={(e, value) =>
                                handlePackSelect(e, value)
                              }
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="horizon-form">
                    <div className="custom-3">
                      <label>{lang("dailySellout.salesCompanyProducts")}</label>
                    </div>
                    <div className="custom-9">
                      <div className="row">
                        <div className="col-md-3 mt-3 mb-4">
                          <div className="custom-radio d-inline-block">
                            <input
                              type="radio"
                              id="ALL"
                              name="salesCompany"
                              value="ALL"
                              onChange={(e) => handleSalesCompanyChange(e)}
                              defaultChecked
                            />
                            <label htmlFor="ALL">
                              {lang("dailySellout.all")}
                            </label>
                          </div>
                        </div>
                        <div className="col-md-3 mt-3 mb-4">
                          <div className="custom-radio d-inline-block">
                            <input
                              type="radio"
                              id="1"
                              name="salesCompany"
                              value="1"
                              onChange={(e) => handleSalesCompanyChange(e)}
                            />
                            <label htmlFor="1">
                              {lang("dailySellout.janssenProduct")}
                            </label>
                          </div>
                        </div>
                        <div className="col-md-3 mt-3 mb-4">
                          <div className="custom-radio d-inline-block">
                            <input
                              type="radio"
                              id="9"
                              name="salesCompany"
                              value="9"
                              onChange={(e) => handleSalesCompanyChange(e)}
                            />
                            <label htmlFor="9">
                              {lang("dailySellout.mainProduct")}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="horizon-form mt-3 mb-4">
                    <div className="custom-3">
                      <label>{lang("dailySellout.sortItems")}</label>
                    </div>
                    <div className="custom-9">
                      <div className="row">
                        <div className="col-md-3 mt-3 mb-4">
                          <div className="custom-radio d-inline-block">
                            <input
                              type="radio"
                              id="currentYear"
                              name="sort-order"
                              value="currentYear"
                              onChange={(e) => handleSortItem(e)}
                              defaultChecked
                            />
                            <label htmlFor="currentYear">
                              {lang("dailySellout.currentYear")}
                            </label>
                          </div>
                        </div>
                        <div className="col-md-3 mt-3 mb-4">
                          <div className="custom-radio d-inline-block">
                            <input
                              type="radio"
                              id="lastYear"
                              name="sort-order"
                              value="lastYear"
                              onChange={(e) => handleSortItem(e)}
                            />
                            <label htmlFor="lastYear">
                              {lang("dailySellout.lastYear")}
                            </label>
                          </div>
                        </div>
                        <div className="col-md-3 mt-3 mb-4">
                          <div className="custom-radio d-inline-block">
                            <input
                              type="radio"
                              id="yearBeforeLast"
                              name="sort-order"
                              value="yearBeforeLast"
                              onChange={(e) => handleSortItem(e)}
                            />
                            <label htmlFor="yearBeforeLast">
                              {lang("dailySellout.yearBeforeLast")}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="horizon-form mt-3 mb-4">
                    <div className="custom-3">
                      <label>{lang("dailySellout.numericalItems")}</label>
                    </div>
                    <div className="custom-9">
                      <div className="row">
                        <div className="col-md-3 mt-3 mb-4">
                          <div className="custom-radio d-inline-block">
                            <input
                              type="radio"
                              id="salesAmount"
                              name="numerical-order"
                              value="salesAmount"
                              onChange={(e) => handleNumericalItem(e)}
                              defaultChecked
                            />
                            <label htmlFor="salesAmount">
                              {lang("dailySellout.salesAmount")}
                            </label>
                          </div>
                        </div>
                        <div className="col-md-3 mt-3 mb-4">
                          <div className="custom-radio d-inline-block">
                            <input
                              type="radio"
                              id="packageQuantity"
                              name="numerical-order"
                              value="packageQuantity"
                              onChange={(e) => handleNumericalItem(e)}
                            />
                            <label htmlFor="packageQuantity">
                              {lang("dailySellout.packageQuantity")}
                            </label>
                          </div>
                        </div>
                        <div className="col-md-3 mt-3 mb-4">
                          <div className="custom-radio d-inline-block">
                            <input
                              type="radio"
                              id="bulkQuantity"
                              name="numerical-order"
                              value="bulkQuantity"
                              onChange={(e) => handleNumericalItem(e)}
                            />
                            <label htmlFor="bulkQuantity">
                              {lang("dailySellout.bulkQuantity")}
                            </label>
                          </div>
                        </div>
                        <div className="col-md-3 mt-3 mb-4">
                          <div className="custom-radio d-inline-block">
                            <input
                              type="radio"
                              id="salesAmountByWholesalerPurchasePrice"
                              name="numerical-order"
                              value="salesAmountByWholesalerPurchasePrice"
                              onChange={(e) => handleNumericalItem(e)}
                            />
                            <label htmlFor="salesAmountByWholesalerPurchasePrice">
                              {lang(
                                "dailySellout.salesAmountByWholesalerPurchasePrice"
                              )}
                            </label>
                          </div>
                        </div>
                        <div className="col-md-3 mt-3 mb-4">
                          <div className="custom-radio d-inline-block">
                            <input
                              type="radio"
                              id="salesAmountByCustomerPurchasePrice"
                              name="numerical-order"
                              value="salesAmountByCustomerPurchasePrice"
                              onChange={(e) => handleNumericalItem(e)}
                            />
                            <label htmlFor="salesAmountByCustomerPurchasePrice">
                              {lang(
                                "dailySellout.salesAmountByCustomerPurchasePrice"
                              )}
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="horizon-form mt-3 mb-4">
                    <div className="custom-3">
                      <label>{lang("dailySellout.hempLaw")}</label>
                    </div>
                    <div className="custom-9">
                      <div className="row">
                        <div className="col-md-6">
                          <Select
                            className="ant-select"
                            mode="multiple"
                            options={hempLawList}
                            placeholder={lang("dailySellout.hempLaw")}
                            onChange={handeHempLawChange}
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="mt-4">
                    <button
                      className="btn btn-primary"
                      onClick={getSelloutRotationWholesalerReport}
                      disabled={loading}
                    >
                      {lang("dailySellout.display")}
                    </button>
                  </div>
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          {reportListing && reportListing.length > 0 && loading === false && (
            <div className="card">
              <div className="card-body">
                <p className="record-total">
                  {lang("territoryDefinitionMaintenance.totalRecords")} -{" "}
                  {reportListing && reportListing.length} / {total}
                </p>
                <div
                  // ref={containerRef}
                  // onBottom={handleContainerOnBottom}
                  className="table-responsive mb-0 hover-table max-height"
                >
                  {duration === "fixedMonthJP" && (
                    <table className="table" aria-describedby="table">
                      <thead>
                        <tr>
                          <th
                            scope="col"
                            onClick={() =>
                              handleSortingData({
                                column: "wholesale_corporation_name",
                                sortOrder:
                                  sortCorporationName === "desc"
                                    ? "asc"
                                    : "desc",
                              })
                            }
                          >
                            <div className="cursor-pointer">
                              {lang("dailySellout.corporationName")}
                              <em className="bx bxs-sort-alt"></em>
                            </div>
                          </th>
                          <th
                            scope="col"
                            onClick={() =>
                              handleSortingData({
                                column: "delivered_facility_name",
                                sortOrder:
                                  sortDeliveryFacility === "desc"
                                    ? "asc"
                                    : "desc",
                              })
                            }
                          >
                            <div className="cursor-pointer">
                              {lang("dailySellout.deliveredFacilityName")}
                              <em className="bx bxs-sort-alt"></em>
                            </div>
                          </th>
                          {headers.includes("product_l") && (
                            <th
                              scope="col"
                              onClick={() =>
                                handleSortingData({
                                  column: "product_l",
                                  sortOrder:
                                    sortProduct === "desc" ? "asc" : "desc",
                                })
                              }
                            >
                              <div className="cursor-pointer">
                                {lang("dailySellout.productL")}
                                <em className="bx bxs-sort-alt"></em>
                              </div>
                            </th>
                          )}
                          {headers.includes("market_authorization_l") && (
                            <th
                              scope="col"
                              onClick={() =>
                                handleSortingData({
                                  column: "market_authorization_l",
                                  sortOrder:
                                    sortMarket === "desc" ? "asc" : "desc",
                                })
                              }
                            >
                              <div className="cursor-pointer">
                                {lang("dailySellout.marketAuthorizationL")}
                                <em className="bx bxs-sort-alt"></em>
                              </div>
                            </th>
                          )}
                          {headers.includes("form_l") && (
                            <th
                              scope="col"
                              onClick={() =>
                                handleSortingData({
                                  column: "form_l",
                                  sortOrder:
                                    sortForm === "desc" ? "asc" : "desc",
                                })
                              }
                            >
                              <div className="cursor-pointer">
                                {lang("dailySellout.formL")}
                                <em className="bx bxs-sort-alt"></em>
                              </div>
                            </th>
                          )}
                          {headers.includes("formulation_l") && (
                            <th
                              scope="col"
                              onClick={() =>
                                handleSortingData({
                                  column: "formulation_l",
                                  sortOrder:
                                    sortFormulation === "desc" ? "asc" : "desc",
                                })
                              }
                            >
                              <div className="cursor-pointer">
                                {lang("dailySellout.formulationL")}
                                <em className="bx bxs-sort-alt"></em>
                              </div>
                            </th>
                          )}
                          {headers.includes("pack_l") && (
                            <th
                              scope="col"
                              onClick={() =>
                                handleSortingData({
                                  column: "pack_l",
                                  sortOrder:
                                    sortPack === "desc" ? "asc" : "desc",
                                })
                              }
                            >
                              <div className="cursor-pointer">
                                {lang("dailySellout.packL")}
                                <em className="bx bxs-sort-alt"></em>
                              </div>
                            </th>
                          )}
                          <th scope="col">
                            <div className="cursor-pointer">
                              {lang("dailySellout.year")}
                              {/* <em className="bx bxs-sort-alt"></em> */}
                            </div>
                          </th>
                          <th scope="col">
                            <div className="cursor-pointer">
                              {lang("dailySellout.jan")}
                              {/* <em className="bx bxs-sort-alt"></em> */}
                            </div>
                          </th>
                          <th scope="col">
                            <div className="cursor-pointer">
                              {lang("dailySellout.feb")}
                              {/* <em className="bx bxs-sort-alt"></em> */}
                            </div>
                          </th>
                          <th scope="col">
                            <div className="cursor-pointer">
                              {lang("dailySellout.march")}
                              {/* <em className="bx bxs-sort-alt"></em> */}
                            </div>
                          </th>
                          <th scope="col">
                            <div className="cursor-pointer">
                              {lang("dailySellout.april")}
                              {/* <em className="bx bxs-sort-alt"></em> */}
                            </div>
                          </th>
                          <th scope="col">
                            <div className="cursor-pointer">
                              {lang("dailySellout.may")}
                              {/* <em className="bx bxs-sort-alt"></em> */}
                            </div>
                          </th>
                          <th scope="col">
                            <div className="cursor-pointer">
                              {lang("dailySellout.june")}
                              {/* <em className="bx bxs-sort-alt"></em> */}
                            </div>
                          </th>
                          <th scope="col">
                            <div className="cursor-pointer">
                              {lang("dailySellout.july")}
                              {/* <em className="bx bxs-sort-alt"></em> */}
                            </div>
                          </th>
                          <th scope="col">
                            <div className="cursor-pointer">
                              {lang("dailySellout.august")}
                              {/* <em className="bx bxs-sort-alt"></em> */}
                            </div>
                          </th>
                          <th scope="col">
                            <div className="cursor-pointer">
                              {lang("dailySellout.sept")}
                              {/* <em className="bx bxs-sort-alt"></em> */}
                            </div>
                          </th>
                          <th scope="col">
                            <div className="cursor-pointer">
                              {lang("dailySellout.oct")}
                              {/* <em className="bx bxs-sort-alt"></em> */}
                            </div>
                          </th>
                          <th scope="col">
                            <div className="cursor-pointer">
                              {lang("dailySellout.nov")}
                              {/* <em className="bx bxs-sort-alt"></em> */}
                            </div>
                          </th>
                          <th scope="col">
                            <div className="cursor-pointer">
                              {lang("dailySellout.dec")}
                              {/* <em className="bx bxs-sort-alt"></em> */}
                            </div>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {reportListing &&
                          reportListing.length > 0 &&
                          reportListing.map((report,index) => {
                            let yearList = [];
                            yearList = Object.keys(report.monthlydata.January);
                            return (
                              <tr key={index}>
                                <td>{report.wholesale_corporation_name}</td>
                                <td>{report.delivered_facility_name}</td>
                                {headers.includes("product_l") && (
                                  <td>{report.product_l}</td>
                                )}
                                {headers.includes("market_authorization_l") && (
                                  <td>{report.market_authorization_l}</td>
                                )}
                                {headers.includes("form_l") && (
                                  <td>{report.form_l}</td>
                                )}
                                {headers.includes("formulation_l") && (
                                  <td>{report.formulation_l}</td>
                                )}
                                {headers.includes("pack_l") && (
                                  <td>{report.pack_l}</td>
                                )}
                                <td>
                                  {yearList.map((year, index) => {
                                    return (
                                      <React.Fragment key={index}>
                                        <span>{year}</span>
                                        <br />
                                      </React.Fragment>
                                    );
                                  })}
                                </td>
                                <td>
                                  {Object.values(
                                    report.monthlydata.January
                                  ).map((val, index) => {
                                    return (
                                      <React.Fragment key={index}>
                                        <span>{val}</span>
                                        <br />
                                      </React.Fragment>
                                    );
                                  })}
                                </td>
                                <td>
                                  {Object.values(
                                    report.monthlydata.February
                                  ).map((val, index) => {
                                    return (
                                      <React.Fragment key={index}>
                                        <span>{val}</span>
                                        <br />
                                      </React.Fragment>
                                    );
                                  })}
                                </td>
                                <td>
                                  {Object.values(report.monthlydata.March).map(
                                    (val, index) => {
                                      return (
                                        <React.Fragment key={index}>
                                          <span>{val}</span>
                                          <br />
                                        </React.Fragment>
                                      );
                                    }
                                  )}
                                </td>
                                <td>
                                  {Object.values(report.monthlydata.April).map(
                                    (val, index) => {
                                      return (
                                        <React.Fragment key={index}>
                                          <span>{val}</span>
                                          <br />
                                        </React.Fragment>
                                      );
                                    }
                                  )}
                                </td>
                                <td>
                                  {Object.values(report.monthlydata.May).map(
                                    (val, index) => {
                                      return (
                                        <React.Fragment key={index}>
                                          <span>{val}</span>
                                          <br />
                                        </React.Fragment>
                                      );
                                    }
                                  )}
                                </td>
                                <td>
                                  {Object.values(report.monthlydata.June).map(
                                    (val, index) => {
                                      return (
                                        <React.Fragment key={index}>
                                          <span>{val}</span>
                                          <br />
                                        </React.Fragment>
                                      );
                                    }
                                  )}
                                </td>
                                <td>
                                  {Object.values(report.monthlydata.July).map(
                                    (val, index) => {
                                      return (
                                        <React.Fragment key={index}>
                                          <span>{val}</span>
                                          <br />
                                        </React.Fragment>
                                      );
                                    }
                                  )}
                                </td>
                                <td>
                                  {Object.values(report.monthlydata.August).map(
                                    (val, index) => {
                                      return (
                                        <React.Fragment key={index}>
                                          <span>{val}</span>
                                          <br />
                                        </React.Fragment>
                                      );
                                    }
                                  )}
                                </td>
                                <td>
                                  {Object.values(
                                    report.monthlydata.September
                                  ).map((val, index) => {
                                    return (
                                      <React.Fragment key={index}>
                                        <span>{val}</span>
                                        <br />
                                      </React.Fragment>
                                    );
                                  })}
                                </td>
                                <td>
                                  {Object.values(
                                    report.monthlydata.October
                                  ).map((val, index) => {
                                    return (
                                      <React.Fragment key={index}>
                                        <span>{val}</span>
                                        <br />
                                      </React.Fragment>
                                    );
                                  })}
                                </td>
                                <td>
                                  {Object.values(
                                    report.monthlydata.November
                                  ).map((val, index) => {
                                    return (
                                      <React.Fragment key={index}>
                                        <span>{val}</span>
                                        <br />
                                      </React.Fragment>
                                    );
                                  })}
                                </td>
                                <td>
                                  {Object.values(
                                    report.monthlydata.December
                                  ).map((val, index) => {
                                    return (
                                      <React.Fragment key={index}>
                                        <span>{val}</span>
                                        <br />
                                      </React.Fragment>
                                    );
                                  })}
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  )}
                  {duration === "fixedMonthWholesale" && (
                    <table className="table" aria-describedby="table">
                      <thead>
                        <tr>
                          <th
                            scope="col"
                            onClick={() =>
                              handleSortingData({
                                column: "wholesale_corporation_name",
                                sortOrder:
                                  sortCorporationName === "desc"
                                    ? "asc"
                                    : "desc",
                              })
                            }
                          >
                            <div className="cursor-pointer">
                              {lang("dailySellout.corporationName")}
                              <em className="bx bxs-sort-alt"></em>
                            </div>
                          </th>
                          <th
                            scope="col"
                            onClick={() =>
                              handleSortingData({
                                column: "delivered_facility_name",
                                sortOrder:
                                  sortDeliveryFacility === "desc"
                                    ? "asc"
                                    : "desc",
                              })
                            }
                          >
                            <div className="cursor-pointer">
                              {lang("dailySellout.deliveredFacilityName")}
                              <em className="bx bxs-sort-alt"></em>
                            </div>
                          </th>
                          {headers.includes("product_l") && (
                            <th
                              scope="col"
                              onClick={() =>
                                handleSortingData({
                                  column: "product_l",
                                  sortOrder:
                                    sortProduct === "desc" ? "asc" : "desc",
                                })
                              }
                            >
                              <div className="cursor-pointer">
                                {lang("dailySellout.productL")}
                                <em className="bx bxs-sort-alt"></em>
                              </div>
                            </th>
                          )}
                          {headers.includes("market_authorization_l") && (
                            <th
                              scope="col"
                              onClick={() =>
                                handleSortingData({
                                  column: "market_authorization_l",
                                  sortOrder:
                                    sortMarket === "desc" ? "asc" : "desc",
                                })
                              }
                            >
                              <div className="cursor-pointer">
                                {lang("dailySellout.marketAuthorizationL")}
                                <em className="bx bxs-sort-alt"></em>
                              </div>
                            </th>
                          )}
                          {headers.includes("form_l") && (
                            <th
                              scope="col"
                              onClick={() =>
                                handleSortingData({
                                  column: "form_l",
                                  sortOrder:
                                    sortForm === "desc" ? "asc" : "desc",
                                })
                              }
                            >
                              <div className="cursor-pointer">
                                {lang("dailySellout.formL")}
                                <em className="bx bxs-sort-alt"></em>
                              </div>
                            </th>
                          )}
                          {headers.includes("formulation_l") && (
                            <th
                              scope="col"
                              onClick={() =>
                                handleSortingData({
                                  column: "formulation_l",
                                  sortOrder:
                                    sortFormulation === "desc" ? "asc" : "desc",
                                })
                              }
                            >
                              <div className="cursor-pointer">
                                {lang("dailySellout.formulationL")}
                                <em className="bx bxs-sort-alt"></em>
                              </div>
                            </th>
                          )}
                          {headers.includes("pack_l") && (
                            <th
                              scope="col"
                              onClick={() =>
                                handleSortingData({
                                  column: "pack_l",
                                  sortOrder:
                                    sortPack === "desc" ? "asc" : "desc",
                                })
                              }
                            >
                              <div className="cursor-pointer">
                                {lang("dailySellout.packL")}
                                <em className="bx bxs-sort-alt"></em>
                              </div>
                            </th>
                          )}
                          <th scope="col">
                            <div className="cursor-pointer">
                              {lang("dailySellout.year")}
                              {/* <em className="bx bxs-sort-alt"></em> */}
                            </div>
                          </th>
                          <th scope="col">
                            <div className="cursor-pointer">
                              {lang("dailySellout.april")}
                              {/* <em className="bx bxs-sort-alt"></em> */}
                            </div>
                          </th>
                          <th scope="col">
                            <div className="cursor-pointer">
                              {lang("dailySellout.may")}
                              {/* <em className="bx bxs-sort-alt"></em> */}
                            </div>
                          </th>
                          <th scope="col">
                            <div className="cursor-pointer">
                              {lang("dailySellout.june")}
                              {/* <em className="bx bxs-sort-alt"></em> */}
                            </div>
                          </th>
                          <th scope="col">
                            <div className="cursor-pointer">
                              {lang("dailySellout.july")}
                              {/* <em className="bx bxs-sort-alt"></em> */}
                            </div>
                          </th>
                          <th scope="col">
                            <div className="cursor-pointer">
                              {lang("dailySellout.august")}
                              {/* <em className="bx bxs-sort-alt"></em> */}
                            </div>
                          </th>
                          <th scope="col">
                            <div className="cursor-pointer">
                              {lang("dailySellout.sept")}
                              {/* <em className="bx bxs-sort-alt"></em> */}
                            </div>
                          </th>
                          <th scope="col">
                            <div className="cursor-pointer">
                              {lang("dailySellout.oct")}
                              {/* <em className="bx bxs-sort-alt"></em> */}
                            </div>
                          </th>
                          <th scope="col">
                            <div className="cursor-pointer">
                              {lang("dailySellout.nov")}
                              {/* <em className="bx bxs-sort-alt"></em> */}
                            </div>
                          </th>
                          <th scope="col">
                            <div className="cursor-pointer">
                              {lang("dailySellout.dec")}
                              {/* <em className="bx bxs-sort-alt"></em> */}
                            </div>
                          </th>
                          <th scope="col">
                            <div className="cursor-pointer">
                              {lang("dailySellout.jan")}
                              {/* <em className="bx bxs-sort-alt"></em> */}
                            </div>
                          </th>
                          <th scope="col">
                            <div className="cursor-pointer">
                              {lang("dailySellout.feb")}
                              {/* <em className="bx bxs-sort-alt"></em> */}
                            </div>
                          </th>
                          <th scope="col">
                            <div className="cursor-pointer">
                              {lang("dailySellout.march")}
                              {/* <em className="bx bxs-sort-alt"></em> */}
                            </div>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {reportListing &&
                          reportListing.length > 0 &&
                          reportListing.map((report) => {
                            let yearList = [];
                            yearList = Object.keys(report.monthlydata.January);
                            return (
                              <tr>
                                <td>{report.wholesale_corporation_name}</td>
                                <td>{report.delivered_facility_name}</td>
                                {headers.includes("product_l") && (
                                  <td>{report.product_l}</td>
                                )}
                                {headers.includes("market_authorization_l") && (
                                  <td>{report.market_authorization_l}</td>
                                )}
                                {headers.includes("form_l") && (
                                  <td>{report.form_l}</td>
                                )}
                                {headers.includes("formulation_l") && (
                                  <td>{report.formulation_l}</td>
                                )}
                                {headers.includes("pack_l") && (
                                  <td>{report.pack_l}</td>
                                )}
                                <td>
                                  {yearList.map((year, index) => {
                                    return (
                                      <React.Fragment key={index}>
                                        <span>{year}</span>
                                        <br />
                                      </React.Fragment>
                                    );
                                  })}
                                </td>
                                <td>
                                  {Object.values(report.monthlydata.April).map(
                                    (val, index) => {
                                      return (
                                        <React.Fragment key={index}>
                                          <span>{val}</span>
                                          <br />
                                        </React.Fragment>
                                      );
                                    }
                                  )}
                                </td>
                                <td>
                                  {Object.values(report.monthlydata.May).map(
                                    (val, index) => {
                                      return (
                                        <React.Fragment key={index}>
                                          <span>{val}</span>
                                          <br />
                                        </React.Fragment>
                                      );
                                    }
                                  )}
                                </td>
                                <td>
                                  {Object.values(report.monthlydata.June).map(
                                    (val, index) => {
                                      return (
                                        <React.Fragment key={index}>
                                          <span>{val}</span>
                                          <br />
                                        </React.Fragment>
                                      );
                                    }
                                  )}
                                </td>
                                <td>
                                  {Object.values(report.monthlydata.July).map(
                                    (val, index) => {
                                      return (
                                        <React.Fragment key={index}>
                                          <span>{val}</span>
                                          <br />
                                        </React.Fragment>
                                      );
                                    }
                                  )}
                                </td>
                                <td>
                                  {Object.values(report.monthlydata.August).map(
                                    (val, index) => {
                                      return (
                                        <React.Fragment key={index}>
                                          <span>{val}</span>
                                          <br />
                                        </React.Fragment>
                                      );
                                    }
                                  )}
                                </td>
                                <td>
                                  {Object.values(
                                    report.monthlydata.September
                                  ).map((val, index) => {
                                    return (
                                      <React.Fragment key={index}>
                                        <span>{val}</span>
                                        <br />
                                      </React.Fragment>
                                    );
                                  })}
                                </td>
                                <td>
                                  {Object.values(
                                    report.monthlydata.October
                                  ).map((val, index) => {
                                    return (
                                      <React.Fragment key={index}>
                                        <span>{val}</span>
                                        <br />
                                      </React.Fragment>
                                    );
                                  })}
                                </td>
                                <td>
                                  {Object.values(
                                    report.monthlydata.November
                                  ).map((val, index) => {
                                    return (
                                      <React.Fragment key={index}>
                                        <span>{val}</span>
                                        <br />
                                      </React.Fragment>
                                    );
                                  })}
                                </td>
                                <td>
                                  {Object.values(
                                    report.monthlydata.December
                                  ).map((val, index) => {
                                    return (
                                      <React.Fragment key={index}>
                                        <span>{val}</span>
                                        <br />
                                      </React.Fragment>
                                    );
                                  })}
                                </td>
                                <td>
                                  {Object.values(
                                    report.monthlydata.January
                                  ).map((val, index) => {
                                    return (
                                      <React.Fragment key={index}>
                                        <span>{val}</span>
                                        <br />
                                      </React.Fragment>
                                    );
                                  })}
                                </td>
                                <td>
                                  {Object.values(
                                    report.monthlydata.February
                                  ).map((val, index) => {
                                    return (
                                      <React.Fragment key={index}>
                                        <span>{val}</span>
                                        <br />
                                      </React.Fragment>
                                    );
                                  })}
                                </td>
                                <td>
                                  {Object.values(report.monthlydata.March).map(
                                    (val, index) => {
                                      return (
                                        <React.Fragment key={index}>
                                          <span>{val}</span>
                                          <br />
                                        </React.Fragment>
                                      );
                                    }
                                  )}
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  )}
                  {duration === "targetPeriod" && (
                    <table className="table" aria-describedby="table">
                      <thead>
                        <tr>
                          <th
                            scope="col"
                            onClick={() =>
                              handleSortingData({
                                column: "wholesale_corporation_name",
                                sortOrder:
                                  sortCorporationName === "desc"
                                    ? "asc"
                                    : "desc",
                              })
                            }
                          >
                            <div className="cursor-pointer">
                              {lang("dailySellout.corporationName")}
                              <em className="bx bxs-sort-alt"></em>
                            </div>
                          </th>
                          <th
                            scope="col"
                            onClick={() =>
                              handleSortingData({
                                column: "delivered_facility_name",
                                sortOrder:
                                  sortDeliveryFacility === "desc"
                                    ? "asc"
                                    : "desc",
                              })
                            }
                          >
                            <div className="cursor-pointer">
                              {lang("dailySellout.deliveredFacilityName")}
                              <em className="bx bxs-sort-alt"></em>
                            </div>
                          </th>
                          {headers.includes("product_l") && (
                            <th
                              scope="col"
                              onClick={() =>
                                handleSortingData({
                                  column: "product_l",
                                  sortOrder:
                                    sortProduct === "desc" ? "asc" : "desc",
                                })
                              }
                            >
                              <div className="cursor-pointer">
                                {lang("dailySellout.productL")}
                                <em className="bx bxs-sort-alt"></em>
                              </div>
                            </th>
                          )}
                          {headers.includes("market_authorization_l") && (
                            <th
                              scope="col"
                              onClick={() =>
                                handleSortingData({
                                  column: "market_authorization_l",
                                  sortOrder:
                                    sortMarket === "desc" ? "asc" : "desc",
                                })
                              }
                            >
                              <div className="cursor-pointer">
                                {lang("dailySellout.marketAuthorizationL")}
                                <em className="bx bxs-sort-alt"></em>
                              </div>
                            </th>
                          )}
                          {headers.includes("form_l") && (
                            <th
                              scope="col"
                              onClick={() =>
                                handleSortingData({
                                  column: "form_l",
                                  sortOrder:
                                    sortForm === "desc" ? "asc" : "desc",
                                })
                              }
                            >
                              <div className="cursor-pointer">
                                {lang("dailySellout.formL")}
                                <em className="bx bxs-sort-alt"></em>
                              </div>
                            </th>
                          )}
                          {headers.includes("formulation_l") && (
                            <th
                              scope="col"
                              onClick={() =>
                                handleSortingData({
                                  column: "formulation_l",
                                  sortOrder:
                                    sortFormulation === "desc" ? "asc" : "desc",
                                })
                              }
                            >
                              <div className="cursor-pointer">
                                {lang("dailySellout.formulationL")}
                                <em className="bx bxs-sort-alt"></em>
                              </div>
                            </th>
                          )}
                          {headers.includes("pack_l") && (
                            <th
                              scope="col"
                              onClick={() =>
                                handleSortingData({
                                  column: "pack_l",
                                  sortOrder:
                                    sortPack === "desc" ? "asc" : "desc",
                                })
                              }
                            >
                              <div className="cursor-pointer">
                                {lang("dailySellout.packL")}
                                <em className="bx bxs-sort-alt"></em>
                              </div>
                            </th>
                          )}
                          {targetPeriodYearList.map((year,index) => {
                            return (
                              <th scope="col" colspan="12" key={index}>
                                <div className="cursor-pointer">
                                  {year}
                                  <em className="bx bxs-sort-alt"></em>
                                </div>
                              </th>
                            );
                          })}
                        </tr>
                        <tr>
                          <th></th>
                          <th></th>
                          {headers.includes("product_l") && <th></th>}
                          {headers.includes("market_authorization_l") && (
                            <th></th>
                          )}
                          {headers.includes("form_l") && <th></th>}
                          {headers.includes("formulation_l") && <th></th>}
                          {headers.includes("pack_l") && <th></th>}
                          {targetPeriodYearList[0] &&
                            Object.keys(reportListing[0].monthlydata).includes(
                              "January"
                            ) && (
                              <th scope="col">
                                <div className="cursor-pointer">
                                  {lang("dailySellout.jan")}
                                  <em className="bx bxs-sort-alt"></em>
                                </div>
                              </th>
                            )}
                          {targetPeriodYearList[0] &&
                            Object.keys(reportListing[0].monthlydata).includes(
                              "February"
                            ) && (
                              <th scope="col">
                                <div className="cursor-pointer">
                                  {lang("dailySellout.feb")}
                                  <em className="bx bxs-sort-alt"></em>
                                </div>
                              </th>
                            )}
                          {targetPeriodYearList[0] &&
                            Object.keys(reportListing[0].monthlydata).includes(
                              "March"
                            ) && (
                              <th scope="col">
                                <div className="cursor-pointer">
                                  {lang("dailySellout.march")}
                                  <em className="bx bxs-sort-alt"></em>
                                </div>
                              </th>
                            )}
                          {targetPeriodYearList[0] &&
                            Object.keys(reportListing[0].monthlydata).includes(
                              "April"
                            ) && (
                              <th scope="col">
                                <div className="cursor-pointer">
                                  {lang("dailySellout.april")}
                                  <em className="bx bxs-sort-alt"></em>
                                </div>
                              </th>
                            )}
                          {targetPeriodYearList[0] &&
                            Object.keys(reportListing[0].monthlydata).includes(
                              "May"
                            ) && (
                              <th scope="col">
                                <div className="cursor-pointer">
                                  {lang("dailySellout.may")}
                                  <em className="bx bxs-sort-alt"></em>
                                </div>
                              </th>
                            )}
                          {targetPeriodYearList[0] &&
                            Object.keys(reportListing[0].monthlydata).includes(
                              "June"
                            ) && (
                              <th scope="col">
                                <div className="cursor-pointer">
                                  {lang("dailySellout.june")}
                                  <em className="bx bxs-sort-alt"></em>
                                </div>
                              </th>
                            )}
                          {targetPeriodYearList[0] &&
                            Object.keys(reportListing[0].monthlydata).includes(
                              "July"
                            ) && (
                              <th scope="col">
                                <div className="cursor-pointer">
                                  {lang("dailySellout.july")}
                                  <em className="bx bxs-sort-alt"></em>
                                </div>
                              </th>
                            )}
                          {targetPeriodYearList[0] &&
                            Object.keys(reportListing[0].monthlydata).includes(
                              "August"
                            ) && (
                              <th scope="col">
                                <div className="cursor-pointer">
                                  {lang("dailySellout.august")}
                                  <em className="bx bxs-sort-alt"></em>
                                </div>
                              </th>
                            )}
                          {targetPeriodYearList[0] &&
                            Object.keys(reportListing[0].monthlydata).includes(
                              "September"
                            ) && (
                              <th scope="col">
                                <div className="cursor-pointer">
                                  {lang("dailySellout.sept")}
                                  <em className="bx bxs-sort-alt"></em>
                                </div>
                              </th>
                            )}
                          {targetPeriodYearList[0] &&
                            Object.keys(reportListing[0].monthlydata).includes(
                              "October"
                            ) && (
                              <th scope="col">
                                <div className="cursor-pointer">
                                  {lang("dailySellout.oct")}
                                  <em className="bx bxs-sort-alt"></em>
                                </div>
                              </th>
                            )}
                          {targetPeriodYearList[0] &&
                            Object.keys(reportListing[0].monthlydata).includes(
                              "November"
                            ) && (
                              <th scope="col">
                                <div className="cursor-pointer">
                                  {lang("dailySellout.nov")}
                                  <em className="bx bxs-sort-alt"></em>
                                </div>
                              </th>
                            )}
                          {targetPeriodYearList[0] &&
                            Object.keys(reportListing[0].monthlydata).includes(
                              "December"
                            ) && (
                              <th scope="col">
                                <div className="cursor-pointer">
                                  {lang("dailySellout.dec")}
                                  <em className="bx bxs-sort-alt"></em>
                                </div>
                              </th>
                            )}
                          {targetPeriodYearList[1] &&
                            Object.keys(reportListing[0].monthlydata).includes(
                              "January"
                            ) && (
                              <th scope="col">
                                <div className="cursor-pointer">
                                  {lang("dailySellout.jan")}
                                  <em className="bx bxs-sort-alt"></em>
                                </div>
                              </th>
                            )}
                          {targetPeriodYearList[1] &&
                            Object.keys(reportListing[0].monthlydata).includes(
                              "February"
                            ) && (
                              <th scope="col">
                                <div className="cursor-pointer">
                                  {lang("dailySellout.feb")}
                                  <em className="bx bxs-sort-alt"></em>
                                </div>
                              </th>
                            )}
                          {targetPeriodYearList[1] &&
                            Object.keys(reportListing[0].monthlydata).includes(
                              "March"
                            ) && (
                              <th scope="col">
                                <div className="cursor-pointer">
                                  {lang("dailySellout.march")}
                                  <em className="bx bxs-sort-alt"></em>
                                </div>
                              </th>
                            )}
                          {targetPeriodYearList[1] &&
                            Object.keys(reportListing[0].monthlydata).includes(
                              "April"
                            ) && (
                              <th scope="col">
                                <div className="cursor-pointer">
                                  {lang("dailySellout.april")}
                                  <em className="bx bxs-sort-alt"></em>
                                </div>
                              </th>
                            )}
                          {targetPeriodYearList[1] &&
                            Object.keys(reportListing[0].monthlydata).includes(
                              "May"
                            ) && (
                              <th scope="col">
                                <div className="cursor-pointer">
                                  {lang("dailySellout.may")}
                                  <em className="bx bxs-sort-alt"></em>
                                </div>
                              </th>
                            )}
                          {targetPeriodYearList[1] &&
                            Object.keys(reportListing[0].monthlydata).includes(
                              "June"
                            ) && (
                              <th scope="col">
                                <div className="cursor-pointer">
                                  {lang("dailySellout.june")}
                                  <em className="bx bxs-sort-alt"></em>
                                </div>
                              </th>
                            )}
                          {targetPeriodYearList[1] &&
                            Object.keys(reportListing[0].monthlydata).includes(
                              "July"
                            ) && (
                              <th scope="col">
                                <div className="cursor-pointer">
                                  {lang("dailySellout.july")}
                                  <em className="bx bxs-sort-alt"></em>
                                </div>
                              </th>
                            )}
                          {targetPeriodYearList[1] &&
                            Object.keys(reportListing[0].monthlydata).includes(
                              "August"
                            ) && (
                              <th scope="col">
                                <div className="cursor-pointer">
                                  {lang("dailySellout.august")}
                                  <em className="bx bxs-sort-alt"></em>
                                </div>
                              </th>
                            )}
                          {targetPeriodYearList[1] &&
                            Object.keys(reportListing[0].monthlydata).includes(
                              "September"
                            ) && (
                              <th scope="col">
                                <div className="cursor-pointer">
                                  {lang("dailySellout.sept")}
                                  <em className="bx bxs-sort-alt"></em>
                                </div>
                              </th>
                            )}
                          {targetPeriodYearList[1] &&
                            Object.keys(reportListing[0].monthlydata).includes(
                              "October"
                            ) && (
                              <th scope="col">
                                <div className="cursor-pointer">
                                  {lang("dailySellout.oct")}
                                  <em className="bx bxs-sort-alt"></em>
                                </div>
                              </th>
                            )}
                          {targetPeriodYearList[1] &&
                            Object.keys(reportListing[0].monthlydata).includes(
                              "November"
                            ) && (
                              <th scope="col">
                                <div className="cursor-pointer">
                                  {lang("dailySellout.nov")}
                                  <em className="bx bxs-sort-alt"></em>
                                </div>
                              </th>
                            )}
                          {targetPeriodYearList[1] &&
                            Object.keys(reportListing[0].monthlydata).includes(
                              "December"
                            ) && (
                              <th scope="col">
                                <div className="cursor-pointer">
                                  {lang("dailySellout.dec")}
                                  <em className="bx bxs-sort-alt"></em>
                                </div>
                              </th>
                            )}
                          {targetPeriodYearList[2] &&
                            Object.keys(reportListing[0].monthlydata).includes(
                              "January"
                            ) && (
                              <th scope="col">
                                <div className="cursor-pointer">
                                  {lang("dailySellout.jan")}
                                  <em className="bx bxs-sort-alt"></em>
                                </div>
                              </th>
                            )}
                          {targetPeriodYearList[2] &&
                            Object.keys(reportListing[0].monthlydata).includes(
                              "February"
                            ) && (
                              <th scope="col">
                                <div className="cursor-pointer">
                                  {lang("dailySellout.feb")}
                                  <em className="bx bxs-sort-alt"></em>
                                </div>
                              </th>
                            )}
                          {targetPeriodYearList[2] &&
                            Object.keys(reportListing[0].monthlydata).includes(
                              "March"
                            ) && (
                              <th scope="col">
                                <div className="cursor-pointer">
                                  {lang("dailySellout.march")}
                                  <em className="bx bxs-sort-alt"></em>
                                </div>
                              </th>
                            )}
                          {targetPeriodYearList[2] &&
                            Object.keys(reportListing[0].monthlydata).includes(
                              "April"
                            ) && (
                              <th scope="col">
                                <div className="cursor-pointer">
                                  {lang("dailySellout.april")}
                                  <em className="bx bxs-sort-alt"></em>
                                </div>
                              </th>
                            )}
                          {targetPeriodYearList[2] &&
                            Object.keys(reportListing[0].monthlydata).includes(
                              "May"
                            ) && (
                              <th scope="col">
                                <div className="cursor-pointer">
                                  {lang("dailySellout.may")}
                                  <em className="bx bxs-sort-alt"></em>
                                </div>
                              </th>
                            )}
                          {targetPeriodYearList[2] &&
                            Object.keys(reportListing[0].monthlydata).includes(
                              "June"
                            ) && (
                              <th scope="col">
                                <div className="cursor-pointer">
                                  {lang("dailySellout.june")}
                                  <em className="bx bxs-sort-alt"></em>
                                </div>
                              </th>
                            )}
                          {targetPeriodYearList[2] &&
                            Object.keys(reportListing[0].monthlydata).includes(
                              "July"
                            ) && (
                              <th scope="col">
                                <div className="cursor-pointer">
                                  {lang("dailySellout.july")}
                                  <em className="bx bxs-sort-alt"></em>
                                </div>
                              </th>
                            )}
                          {targetPeriodYearList[2] &&
                            Object.keys(reportListing[0].monthlydata).includes(
                              "August"
                            ) && (
                              <th scope="col">
                                <div className="cursor-pointer">
                                  {lang("dailySellout.august")}
                                  <em className="bx bxs-sort-alt"></em>
                                </div>
                              </th>
                            )}
                          {targetPeriodYearList[2] &&
                            Object.keys(reportListing[0].monthlydata).includes(
                              "September"
                            ) && (
                              <th scope="col">
                                <div className="cursor-pointer">
                                  {lang("dailySellout.sept")}
                                  <em className="bx bxs-sort-alt"></em>
                                </div>
                              </th>
                            )}
                          {targetPeriodYearList[2] &&
                            Object.keys(reportListing[0].monthlydata).includes(
                              "October"
                            ) && (
                              <th scope="col">
                                <div className="cursor-pointer">
                                  {lang("dailySellout.oct")}
                                  <em className="bx bxs-sort-alt"></em>
                                </div>
                              </th>
                            )}
                          {targetPeriodYearList[2] &&
                            Object.keys(reportListing[0].monthlydata).includes(
                              "November"
                            ) && (
                              <th scope="col">
                                <div className="cursor-pointer">
                                  {lang("dailySellout.nov")}
                                  <em className="bx bxs-sort-alt"></em>
                                </div>
                              </th>
                            )}
                          {targetPeriodYearList[2] &&
                            Object.keys(reportListing[0].monthlydata).includes(
                              "December"
                            ) && (
                              <th scope="col">
                                <div className="cursor-pointer">
                                  {lang("dailySellout.dec")}
                                  <em className="bx bxs-sort-alt"></em>
                                </div>
                              </th>
                            )}
                        </tr>
                      </thead>
                      <tbody>
                        {reportListing &&
                          reportListing.length > 0 &&
                          reportListing.map((report,index) => {
                            let yearList = [];
                            // Object.values(report.monthlydata.January);
                            let months = Object.keys(report.monthlydata);
                            let firstMonth = months[0];
                            yearList = Object.keys(
                              report.monthlydata[firstMonth]
                            );
                            return (
                              <tr key={index}>
                                <td>{report.wholesale_corporation_name}</td>
                                <td>{report.delivered_facility_name}</td>
                                {headers.includes("product_l") && (
                                  <td>{report.product_l}</td>
                                )}
                                {headers.includes("market_authorization_l") && (
                                  <td>{report.market_authorization_l}</td>
                                )}
                                {headers.includes("form_l") && (
                                  <td>{report.form_l}</td>
                                )}
                                {headers.includes("formulation_l") && (
                                  <td>{report.formulation_l}</td>
                                )}
                                {headers.includes("pack_l") && (
                                  <td>{report.pack_l}</td>
                                )}
                                {yearList[0] && months.includes("January") && (
                                  <td>
                                    {report.monthlydata.January[yearList[0]]
                                      ? report.monthlydata.January[yearList[0]]
                                      : ""}
                                  </td>
                                )}
                                {yearList[0] && months.includes("February") && (
                                  <td>
                                    {report.monthlydata.February[yearList[0]]
                                      ? report.monthlydata.February[yearList[0]]
                                      : ""}
                                  </td>
                                )}
                                {yearList[0] && months.includes("March") && (
                                  <td>
                                    {report.monthlydata.March[yearList[0]]
                                      ? report.monthlydata.March[yearList[0]]
                                      : ""}
                                  </td>
                                )}
                                {yearList[0] && months.includes("April") && (
                                  <td>
                                    {report.monthlydata.April[yearList[0]]
                                      ? report.monthlydata.April[yearList[0]]
                                      : ""}
                                  </td>
                                )}
                                {yearList[0] && months.includes("May") && (
                                  <td>
                                    {report.monthlydata.May[yearList[0]]
                                      ? report.monthlydata.May[yearList[0]]
                                      : ""}
                                  </td>
                                )}
                                {yearList[0] && months.includes("June") && (
                                  <td>
                                    {report.monthlydata.June[yearList[0]]
                                      ? report.monthlydata.June[yearList[0]]
                                      : ""}
                                  </td>
                                )}
                                {yearList[0] && months.includes("July") && (
                                  <td>
                                    {report.monthlydata.July[yearList[0]]
                                      ? report.monthlydata.July[yearList[0]]
                                      : ""}
                                  </td>
                                )}
                                {yearList[0] && months.includes("August") && (
                                  <td>
                                    {report.monthlydata.August[yearList[0]]
                                      ? report.monthlydata.August[yearList[0]]
                                      : ""}
                                  </td>
                                )}
                                {yearList[0] &&
                                  months.includes("September") && (
                                    <td>
                                      {report.monthlydata.September[yearList[0]]
                                        ? report.monthlydata.September[
                                            yearList[0]
                                          ]
                                        : ""}
                                    </td>
                                  )}
                                {yearList[0] && months.includes("October") && (
                                  <td>
                                    {report.monthlydata.October[yearList[0]]
                                      ? report.monthlydata.October[yearList[0]]
                                      : ""}
                                  </td>
                                )}
                                {yearList[0] && months.includes("November") && (
                                  <td>
                                    {report.monthlydata.November[yearList[0]]
                                      ? report.monthlydata.November[yearList[0]]
                                      : ""}
                                  </td>
                                )}
                                {yearList[0] && months.includes("December") && (
                                  <td>
                                    {report.monthlydata.December[yearList[0]]
                                      ? report.monthlydata.December[yearList[0]]
                                      : ""}
                                  </td>
                                )}
                                {yearList[1] && months.includes("January") && (
                                  <td>
                                    {report.monthlydata.January[yearList[1]]
                                      ? report.monthlydata.January[yearList[1]]
                                      : ""}
                                  </td>
                                )}
                                {yearList[1] && months.includes("February") && (
                                  <td>
                                    {report.monthlydata.February[yearList[1]]
                                      ? report.monthlydata.February[yearList[1]]
                                      : ""}
                                  </td>
                                )}
                                {yearList[1] && months.includes("March") && (
                                  <td>
                                    {report.monthlydata.March[yearList[1]]
                                      ? report.monthlydata.March[yearList[1]]
                                      : ""}
                                  </td>
                                )}
                                {yearList[1] && months.includes("April") && (
                                  <td>
                                    {report.monthlydata.April[yearList[1]]
                                      ? report.monthlydata.April[yearList[1]]
                                      : ""}
                                  </td>
                                )}
                                {yearList[1] && months.includes("May") && (
                                  <td>
                                    {report.monthlydata.May[yearList[1]]
                                      ? report.monthlydata.May[yearList[1]]
                                      : ""}
                                  </td>
                                )}
                                {yearList[1] && months.includes("June") && (
                                  <td>
                                    {report.monthlydata.June[yearList[1]]
                                      ? report.monthlydata.June[yearList[1]]
                                      : ""}
                                  </td>
                                )}
                                {yearList[1] && months.includes("July") && (
                                  <td>
                                    {report.monthlydata.July[yearList[1]]
                                      ? report.monthlydata.July[yearList[1]]
                                      : ""}
                                  </td>
                                )}
                                {yearList[1] && months.includes("August") && (
                                  <td>
                                    {report.monthlydata.August[yearList[1]]
                                      ? report.monthlydata.August[yearList[1]]
                                      : ""}
                                  </td>
                                )}
                                {yearList[1] &&
                                  months.includes("September") && (
                                    <td>
                                      {report.monthlydata.September[yearList[1]]
                                        ? report.monthlydata.September[
                                            yearList[1]
                                          ]
                                        : ""}
                                    </td>
                                  )}
                                {yearList[1] && months.includes("October") && (
                                  <td>
                                    {report.monthlydata.October[yearList[1]]
                                      ? report.monthlydata.October[yearList[1]]
                                      : ""}
                                  </td>
                                )}
                                {yearList[1] && months.includes("November") && (
                                  <td>
                                    {report.monthlydata.November[yearList[1]]
                                      ? report.monthlydata.November[yearList[1]]
                                      : ""}
                                  </td>
                                )}
                                {yearList[1] && months.includes("December") && (
                                  <td>
                                    {report.monthlydata.December[yearList[1]]
                                      ? report.monthlydata.December[yearList[1]]
                                      : ""}
                                  </td>
                                )}
                                {yearList[2] && months.includes("January") && (
                                  <td>
                                    {report.monthlydata.January[yearList[2]]
                                      ? report.monthlydata.January[yearList[2]]
                                      : ""}
                                  </td>
                                )}
                                {yearList[2] && months.includes("February") && (
                                  <td>
                                    {report.monthlydata.February[yearList[2]]
                                      ? report.monthlydata.February[yearList[2]]
                                      : ""}
                                  </td>
                                )}
                                {yearList[2] && months.includes("March") && (
                                  <td>
                                    {report.monthlydata.March[yearList[2]]
                                      ? report.monthlydata.March[yearList[2]]
                                      : ""}
                                  </td>
                                )}
                                {yearList[2] && months.includes("April") && (
                                  <td>
                                    {report.monthlydata.April[yearList[2]]
                                      ? report.monthlydata.April[yearList[2]]
                                      : ""}
                                  </td>
                                )}
                                {yearList[2] && months.includes("May") && (
                                  <td>
                                    {report.monthlydata.May[yearList[2]]
                                      ? report.monthlydata.May[yearList[2]]
                                      : ""}
                                  </td>
                                )}
                                {yearList[2] && months.includes("June") && (
                                  <td>
                                    {report.monthlydata.June[yearList[2]]
                                      ? report.monthlydata.June[yearList[2]]
                                      : ""}
                                  </td>
                                )}
                                {yearList[2] && months.includes("July") && (
                                  <td>
                                    {report.monthlydata.July[yearList[2]]
                                      ? report.monthlydata.July[yearList[2]]
                                      : ""}
                                  </td>
                                )}
                                {yearList[2] && months.includes("August") && (
                                  <td>
                                    {report.monthlydata.August[yearList[2]]
                                      ? report.monthlydata.August[yearList[2]]
                                      : ""}
                                  </td>
                                )}
                                {yearList[2] &&
                                  months.includes("September") && (
                                    <td>
                                      {report.monthlydata.September[yearList[2]]
                                        ? report.monthlydata.September[
                                            yearList[2]
                                          ]
                                        : ""}
                                    </td>
                                  )}
                                {yearList[2] && months.includes("October") && (
                                  <td>
                                    {report.monthlydata.October[yearList[2]]
                                      ? report.monthlydata.October[yearList[2]]
                                      : ""}
                                  </td>
                                )}
                                {yearList[2] && months.includes("November") && (
                                  <td>
                                    {report.monthlydata.November[yearList[2]]
                                      ? report.monthlydata.November[yearList[2]]
                                      : ""}
                                  </td>
                                )}
                                {yearList[2] && months.includes("December") && (
                                  <td>
                                    {report.monthlydata.December[yearList[2]]
                                      ? report.monthlydata.December[yearList[2]]
                                      : ""}
                                  </td>
                                )}
                              </tr>
                            );
                          })}
                      </tbody>
                    </table>
                  )}
                </div>
                <div className="filter-actions mt-4 mb-4">
                  {excelLoading && <Spinner animation="border" />}
                  {lazyLoading && <Spinner animation="border" />}
                  <button
                    className="btn btn-primary"
                    onClick={handleExcelDownload}
                    disabled={excelLoading}
                  >
                    {lang("dailySellout.excelDownload")}
                  </button>
                  {total > 0 && (
                    <button
                      className="btn btn-primary"
                      onClick={loadRecords}
                      disabled={lazyLoading || reportListing.length >= total}
                    >
                      {lang("Buttons.loadMore")}
                    </button>
                  )}
                </div>
              </div>
            </div>
          )}
          {loading === true && <Spinner animation="border" />}
          {noData && <div className="noData">No data found</div>}
          <Modal
            size="md"
            className="withdraw-modal"
            show={showUserMessage}
            onHide={handleCloseUserMessage}
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <Modal.Body>
              <div className="warning-msg">
                <p>{lang("dailySellout.allSelectionConfirmation")}</p>
                <p>{lang("dailySellout.run")}</p>
              </div>
              <div className="buttons-group">
                <button
                  className="btn btn-primary"
                  onClick={handleSelloutRotationReport}
                >
                  {lang("Buttons.ok")}
                </button>
                <button
                  className="btn btn-primary"
                  onClick={handleCloseUserMessage}
                >
                  {lang("Buttons.cancel")}
                </button>
              </div>
            </Modal.Body>
          </Modal>
          <Modal
            size="md"
            className="withdraw-modal"
            show={showDownloadMessage}
            onHide={handleCloseDownloadMessage}
            aria-labelledby="contained-modal-title-vcenter"
            centered
          >
            <Modal.Body>
              <div className="warning-msg">{downloadMessage}</div>
              <div className="buttons-group">
                <button
                  className="btn btn-primary"
                  onClick={handleCloseDownloadMessage}
                >
                  {lang("Buttons.ok")}
                </button>
              </div>
            </Modal.Body>
          </Modal>
        </>
      )}
      {maintenance === "0" && <SalesMaintenance />}
    </Home>
  ) : (
    <Home>
      <p>You don't have required permission to view this page</p>
    </Home>
  );
}

export default SelloutRotationWholesaler;
